import _defineProperty from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _R$_availableAttrs;

import eve from './eve/eve';
import extend, { merge, getArrayCopy, cacher } from './raphael.lib';

var _win = 'undefined' == typeof window ? 'undefined' == typeof global ? null : global : window;

function R(e) {
  var t, n, a;
  return void 0 === R._url && (R._url = E), R.is(e, FUNCTION) ? loaded ? e() : eve.on('raphael.DOMload', e) : R.is(e, ARRAY) ? R._engine.create[APPLY](R, e.splice(0, 3 + R.is(e[0], NU))).add(e) : (n = getArrayCopy(arguments), t = Array.prototype.slice.call(n, 0), R.is(t[t.length - 1], FUNCTION) ? (a = t.pop(), loaded ? a.call(R._engine.create[APPLY](R, t)) : eve.on('raphael.DOMload', function () {
    a.call(R._engine.create[APPLY](R, t));
  })) : R._engine.create[APPLY](R, arguments));
}

R.upgrade = '1.0.0', R.version = '2.1.0', R.eve = eve;

var loaded,
    UNDEF,
    undef,
    __data,
    E = '',
    S = ' ',
    HAS = 'hasOwnProperty',
    APPLY = 'apply',
    CONCAT = 'concat',
    NU = 'number',
    STRING = 'string',
    ARRAY = 'array',
    OBJECT = 'object',
    FINITE = 'finite',
    SPLIT = 'split',
    NONE = 'none',
    BLACK = '#000',
    NULL = 'null',
    FUNCTION = 'function',
    AUTO = 'auto',
    NORMAL = 'normal',
    COMMA = ',',
    TOKEN1 = '$1',
    rCheckRegex = /R/i,
    isIE = /trident/i.test(_win.navigator.userAgent),
    paramCounts = {
  a: 7,
  c: 6,
  h: 1,
  l: 2,
  m: 2,
  r: 4,
  q: 4,
  s: 4,
  t: 2,
  v: 1,
  z: 0
},
    arraySplice = Array.prototype.splice,
    hasPrototypeBug = function () {
  return function () {}.hasOwnProperty('prototype');
}(),
    g = {
  doc: _win.document,
  win: _win
},
    doc = g.doc,
    win = g.win,
    safePointerEventMapping = R.safePointerEventMapping = {
  mouseover: 'pointerover',
  mousedown: 'pointerdown',
  mousemove: 'pointermove',
  mouseup: 'pointerup',
  mouseout: 'pointerout'
},
    navigator = win.navigator,
    supportsTouch = R.supportsTouch = 'ontouchstart' in doc || navigator.maxTouchPoints || navigator.msMaxTouchPoints,
    supportsPointer = R.supportsPointer = 'onpointerover' in doc,
    isEdge = R.isEdge = /Edge/.test(navigator.userAgent),
    isIE11 = R.isIE11 = /trident/i.test(navigator.userAgent) && /rv:11/i.test(navigator.userAgent) && !win.opera,
    isFirefox = R.isFirefox = /Firefox/.test(navigator.userAgent),
    isWindows = R.isWindows = /Windows/.test(navigator.userAgent),
    mStr = 'm',
    lStr = 'l',
    strM = 'M',
    strL = 'L',
    __params = [],
    charRegex = /[a-z]/i,
    pathStringBreakFn = function pathStringBreakFn(e, t, n) {
  var a = t.toLowerCase(),
      r = [],
      o = 0;
  if (__params.length = 0, n.replace(pathValues, function (e, t) {
    t && __params.push(+t);
  }), 'r' === a) __data.push([t][CONCAT](__params));else if ('z' === a) __data.push([t]);else if (__params.length >= paramCounts[a]) {
    for (; o < __params.length;) {
      o % paramCounts[a] ? r.push(__params[o]) : (r.length && __data.push(r) && (r = []), r.push(t, __params[o])), o++;
    }

    __data.push(r);
  }
},
    CustomAttributes = function CustomAttributes() {},
    caproto = R.ca = R.customAttributes = CustomAttributes.prototype,
    Paper = function Paper() {
  this.ca = this.customAttributes = new CustomAttributes(), this._CustomAttributes = function () {}, this._CustomAttributes.prototype = this.ca, this._elementsById = {}, this.id = R._oid++, eve('raphael.new', this);
},
    paperproto = R.fn = Paper.prototype = R.prototype,
    events = 'click dblclick mousedown mousemove mouseout mouseover mouseup touchstart touchmove touchend touchcancel dragstart dragmove dragend'.split(' '),
    touchMap = {
  dragstart: 'touchstart',
  dragmove: 'touchmove',
  dragend: 'touchend'
},
    Str = String,
    toFloat = win.parseFloat,
    toInt = win.parseInt,
    math = Math,
    mmax = math.max,
    mmin = math.min,
    abs = math.abs,
    pow = math.pow,
    mathCos = math.cos,
    mathSin = math.sin,
    mathSqrt = math.sqrt,
    round = math.round,
    PI = math.PI,
    deg2rad = PI / 180,
    rad2deg = 180 / PI,
    lowerCase = Str.prototype.toLowerCase,
    upperCase = Str.prototype.toUpperCase,
    objectToString = Object.prototype.toString,
    separator = /[, ]+/,
    formatrg = /\{(\d+)\}/g,
    colourRegExp = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?)%?\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?)%?\s*\))\s*$/i,
    bezierrg = /^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/,
    commaSpaces = /[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*/,
    p2s = /,?([achlmqrstvxz]),?/gi,
    pathCommaRegex = /,?[a-z],?/i,
    pathCommand = /([achlmrqstvz])[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*)+)/ig,
    tCommand = /([rstm])[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*)+)/ig,
    pathValues = /(-?\d*\.?\d*(?:e[\-+]?\d+)?)[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*/ig,
    isnan = {
  NaN: 1,
  Infinity: 1,
  "-Infinity": 1
},
    hsrg = {
  hs: 1,
  rg: 1
},
    availableAttrs = R._availableAttrs = (_R$_availableAttrs = {
  "arrow-end": 'none',
  "arrow-start": 'none',
  blur: 0,
  "clip-rect": '0 0 1e9 1e9',
  "clip-path": '',
  cursor: 'default',
  cx: 0,
  cy: 0,
  fill: '#fff',
  "fill-opacity": 1,
  font: '10px "Arial"',
  "font-family": '"Arial"',
  "font-size": '10',
  "font-style": 'normal',
  "font-weight": 400,
  gradient: 0,
  height: 0,
  href: 'about:blank',
  "letter-spacing": 0,
  "line-height": 12,
  "vertical-align": 'middle',
  opacity: 1,
  path: 'M0,0',
  r: 0,
  rx: 0,
  ry: 0,
  src: '',
  stroke: '#000',
  "stroke-dasharray": '',
  "stroke-linecap": 'butt',
  "stroke-linejoin": 'butt',
  "stroke-miterlimit": 0,
  "stroke-opacity": 1,
  "stroke-width": 1,
  target: '_blank',
  "text-anchor": 'middle',
  visibility: '',
  title: '',
  transform: '',
  rotation: 0,
  width: 0,
  x: 0,
  y: 0,
  "shape-rendering": 'auto',
  alpha: 'number',
  "font-stretch": 'normal',
  "alignment-baseline": 'auto',
  "baseline-shift": 'auto',
  "clip-rule": 'nonzero',
  direction: 'ltr',
  "dominant-baseline": 'auto',
  "fill-rule": 'nonzero',
  filter: 'none',
  "flood-color": '#000',
  "flood-opacity": 1,
  "font-size-adjust": 'none'
}, _defineProperty(_R$_availableAttrs, "font-stretch", 'normal'), _defineProperty(_R$_availableAttrs, "font-variant", 'normal'), _defineProperty(_R$_availableAttrs, "kerning", 'auto'), _defineProperty(_R$_availableAttrs, "lighting-color", 'white'), _defineProperty(_R$_availableAttrs, "marker-end", 'none'), _defineProperty(_R$_availableAttrs, "marker-mid", 'none'), _defineProperty(_R$_availableAttrs, "marker-start", 'none'), _defineProperty(_R$_availableAttrs, "mask", 'none'), _defineProperty(_R$_availableAttrs, "pointer-events", 'visiblePainted'), _defineProperty(_R$_availableAttrs, "stop-color", '#000'), _defineProperty(_R$_availableAttrs, "stop-opacity", 1), _defineProperty(_R$_availableAttrs, "stroke-dashoffset", 0), _defineProperty(_R$_availableAttrs, "text-decoration", 'none'), _defineProperty(_R$_availableAttrs, "vector-effect", ''), _defineProperty(_R$_availableAttrs, "visibility", 'visible'), _defineProperty(_R$_availableAttrs, "word-spacing", 'normal'), _defineProperty(_R$_availableAttrs, "writing-mode", 'lr-tb'), _R$_availableAttrs),
    availableAnimAttrs = R._availableAnimAttrs = {
  blur: 'number',
  "clip-rect": 'csv',
  "clip-path": 'path',
  cx: 'number',
  cy: 'number',
  fill: 'colour',
  "fill-opacity": 'number',
  "font-size": 'number',
  height: 'number',
  opacity: 'number',
  path: 'path',
  r: 'number',
  rx: 'number',
  ry: 'number',
  stroke: 'colour',
  "stroke-opacity": 'number',
  "stroke-width": 'number',
  transform: 'transform',
  width: 'number',
  x: 'number',
  y: 'number',
  color: 'colour',
  borderColor: 'colour',
  borderWidth: 'number',
  alpha: 'number',
  "text-bound": 'text-bound'
},
    eldata = {},
    sortByNumber = function sortByNumber(e, t) {
  return toFloat(e) - toFloat(t);
},
    fun = function fun() {},
    pipe = function pipe(e) {
  return e;
},
    rectPath = R._rectPath = function (e, t, n, a, i) {
  return i ? [[strM, e + i, t], [lStr, n - 2 * i, 0], ['a', i, i, 0, 0, 1, i, i], [lStr, 0, a - 2 * i], ['a', i, i, 0, 0, 1, -i, i], [lStr, 2 * i - n, 0], ['a', i, i, 0, 0, 1, -i, -i], [lStr, 0, 2 * i - a], ['a', i, i, 0, 0, 1, i, -i], ['z']] : [[strM, e, t], [lStr, n, 0], [lStr, 0, a], [lStr, -n, 0], ['z']];
},
    ellipsePath = function ellipsePath(e, t, n, a) {
  return null == a && (a = n), [[strM, e, t], [mStr, 0, -a], ['a', n, a, 0, 1, 1, 0, 2 * a], ['a', n, a, 0, 1, 1, 0, -2 * a], ['z']];
},
    getPath = R._getPath = {
  group: function group() {
    return !1;
  },
  path: function path(e) {
    return e.attr('path');
  },
  circle: function circle(e) {
    var t = e.attrs;
    return ellipsePath(t.cx, t.cy, t.r);
  },
  ellipse: function ellipse(e) {
    var t = e.attrs;
    return ellipsePath(t.cx, t.cy, t.rx, t.ry);
  },
  rect: function rect(e) {
    var t = e.attrs;
    return rectPath(t.x, t.y, t.width, t.height, t.r);
  },
  image: function image(e) {
    var t = e.attrs;
    return rectPath(t.x, t.y, t.width, t.height);
  },
  text: function text(e) {
    var t = e._getBBox();

    return rectPath(t.x, t.y, t.width, t.height);
  }
},
    mapPath = R.mapPath = function (e, t) {
  if (!t) return e;
  var n, a, r, o, s, l, d;

  for (e = path2curve(e).slice(0), r = 0, s = e.length; r < s; r++) {
    for (d = e[r] = e[r].slice(0), o = 1, l = d.length; o < l; o += 2) {
      n = t.x(d[o], d[o + 1]), a = t.y(d[o], d[o + 1]), d[o] = n, d[o + 1] = a;
    }
  }

  return e;
},
    lastArgIfGroup = R._lastArgIfGroup = function (e, t) {
  var n = e.length - 1,
      a = e[n];
  if (a && a.constructor === R.el.constructor && 'group' === a.type) return t && (e[n] = void 0, delete e[n], arraySplice.call(e, n, 1)), a;
},
    serializeArgs = R._serializeArgs = function (e) {
  var t,
      n,
      a,
      r,
      o = e[0];
  if (R.is(o, OBJECT) && !R.is(o, ARRAY) && 'group' !== o.type) for (n = o, o.path && (t = o.path, t && !R.is(t, STRING) && !R.is(t[0], ARRAY) && (t += E)), (a = 1, r = arguments.length); a < r; a += 2) {
    n[arguments[a]] || (n[arguments[a]] = arguments[a + 1]);
  } else for (n = {}, a = 1, r = arguments.length; a < r; a += 2) {
    n[arguments[a]] = e[(a - 1) / 2] || arguments[a + 1];
  }
  return n;
},
    is = R.is = function (e, t) {
  return t === FINITE ? !isnan[HAS](+e) : t === ARRAY ? e instanceof Array : (t !== OBJECT || e !== undef && null !== e) && (t == NULL && null === e || t == typeof e && null !== e || t == OBJECT && e === Object(e) || t == ARRAY && Array.isArray && Array.isArray(e) || objectToString.call(e).slice(8, -1).toLowerCase() === t);
},
    clone = R.clone = hasPrototypeBug ? function (e) {
  if (Object(e) !== e) return e;
  if (e instanceof Function) return e;
  var t = new e.constructor();

  for (var n in e) {
    'prototype' !== n && e[HAS](n) && (t[n] = clone(e[n]));
  }

  return t;
} : function (e) {
  if (Object(e) !== e) return e;
  if (e instanceof Function) return e;
  var t = new e.constructor();

  for (var n in e) {
    e[HAS](n) && (t[n] = clone(e[n]));
  }

  return t;
},
    Node = _win.Node;

Node && !Node.prototype.contains && (Node.prototype.contains = function (e) {
  for (; e = e.parentNode;) {
    if (e === this) return !0;
  }

  return !1;
}), R._g = g, R.merge = merge, R.extend = extend, R.createUUID = function (e, t) {
  return function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(e, t).toUpperCase();
  };
}(/[xy]/g, function (e) {
  var t = 0 | 16 * math.random(),
      n = 'x' === e ? t : 8 | 3 & t;
  return n.toString(16);
}), R._radial_gradient = /^x?r(?:\(([^\)]*?)\))?/, R._ISURL = /^url\(['"]?([^\)]+?)['"]?\)$/i, R.getElementID = function (e) {
  return 'rr-' + e;
};

function PriorityQueue(e) {
  this._comparator = e, this._elements = [];
}

PriorityQueue.prototype.isEmpty = function () {
  return 0 === this.size();
}, PriorityQueue.prototype.peek = function () {
  return this.isEmpty() ? null : this._elements[0];
}, PriorityQueue.prototype.deq = function () {
  var e = this.peek(),
      t = this._elements.pop(),
      n = this.size();

  if (0 === n) return e;
  this._elements[0] = t;

  for (var a = 0; a < n;) {
    var i = a,
        r = 2 * a + 1,
        o = 2 * a + 2;
    if (r < n && 0 <= this._compare(r, i) && (i = r), o < n && 0 <= this._compare(o, i) && (i = o), i === a) break;
    this._swap(i, a), a = i;
  }

  return e;
}, PriorityQueue.prototype.enq = function (e) {
  for (var t = this._elements.push(e), n = t - 1; 0 < n;) {
    var a = Math.floor((n - 1) / 2);
    if (0 >= this._compare(n, a)) break;
    this._swap(a, n), n = a;
  }

  return t;
}, PriorityQueue.prototype.size = function () {
  return this._elements.length;
}, PriorityQueue.prototype._compare = function (e, t) {
  return this._comparator(this._elements[e], this._elements[t]);
}, PriorityQueue.prototype._swap = function (e, t) {
  var n = this._elements[e];
  this._elements[e] = this._elements[t], this._elements[t] = n;
}, R.type = win.ENABLE_RED_CANVAS && (win.CanvasRenderingContext2D || doc.createElement('canvas').getContext) ? 'CANVAS' : win.SVGAngle || doc.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1') ? 'SVG' : 'VML', R.svg = !((R.vml = 'VML' === R.type) || (R.canvas = 'CANVAS' === R.type)), R._Paper = Paper, R._id = 0, R._oid = 0, R.rad = function (e) {
  return e % 360 * deg2rad;
}, R.deg = function (e) {
  return e * rad2deg % 360;
};

var _toHex = function toHex(e) {
  if (R.vml) {
    var t,
        n = /^\s+|\s+$/g;

    try {
      var a = new ActiveXObject('htmlfile');
      a.write('<body>'), a.close(), t = a.body;
    } catch (n) {
      t = createPopup().document.body;
    }

    var r = t.createTextRange();
    _toHex = cacher(function (e) {
      try {
        t.style.color = Str(e).replace(n, E);
        var a = r.queryCommandValue('ForeColor');
        return a = (255 & a) << 16 | 65280 & a | (16711680 & a) >>> 16, '#' + ('000000' + a.toString(16)).slice(-6);
      } catch (t) {
        return NONE;
      }
    });
  } else {
    var o = g.doc.createElement('i');
    o.title = 'Rapha\xEBl Colour Picker', o.style.display = NONE, g.doc.body.appendChild(o), _toHex = cacher(function (e) {
      return o.style.color = e, g.doc.defaultView.getComputedStyle(o, E).getPropertyValue('color');
    });
  }

  return _toHex(e);
},
    hsbtoString = function hsbtoString() {
  return 'hsb(' + [this.h, this.s, this.b] + ')';
},
    hsltoString = function hsltoString() {
  return 'hsl(' + [this.h, this.s, this.l] + ')';
},
    rgbtoString = function rgbtoString() {
  return this.hex;
},
    prepareRGB = function prepareRGB(e, t, n) {
  if (null == t && is(e, OBJECT) && 'r' in e && 'g' in e && 'b' in e && (n = e.b, t = e.g, e = e.r), null == t && is(e, STRING)) {
    var a = R.getRGB(e);
    e = a.r, t = a.g, n = a.b;
  }

  return (1 < e || 1 < t || 1 < n) && (e /= 255, t /= 255, n /= 255), [e, t, n];
},
    packageRGB = function packageRGB(e, t, n, a) {
  var i = {
    r: e *= 255,
    g: t *= 255,
    b: n *= 255,
    hex: R.rgb(e, t, n),
    toString: rgbtoString
  };
  return is(a, FINITE) && (i.opacity = a), i;
};

R.color = function (e) {
  var t;
  return R.is(e, OBJECT) && 'h' in e && 's' in e && 'b' in e ? (t = R.hsb2rgb(e), e.r = t.r, e.g = t.g, e.b = t.b, e.hex = t.hex) : R.is(e, OBJECT) && 'h' in e && 's' in e && lStr in e ? (t = R.hsl2rgb(e), e.r = t.r, e.g = t.g, e.b = t.b, e.hex = t.hex) : (R.is(e, STRING) && (e = R.getRGB(e)), R.is(e, OBJECT) && 'r' in e && 'g' in e && 'b' in e ? (t = R.rgb2hsl(e), e.h = t.h, e.s = t.s, e.l = t.l, t = R.rgb2hsb(e), e.v = t.b) : (e = {
    hex: NONE
  }, e.r = e.g = e.b = e.h = e.s = e.v = e.l = -1)), e.toString = rgbtoString, e;
}, R.hsb2rgb = function (e, t, n, a) {
  this.is(e, OBJECT) && 'h' in e && 's' in e && 'b' in e && (n = e.b, t = e.s, e = e.h, a = e.o), e *= 360;
  var i, r, l, d, p;
  return e = e % 360 / 60, p = n * t, d = p * (1 - abs(e % 2 - 1)), i = r = l = n - p, e = ~~e, i += [p, d, 0, 0, d, p][e], r += [d, p, p, d, 0, 0][e], l += [0, 0, d, p, p, d][e], packageRGB(i, r, l, a);
}, R.hsl2rgb = function (e, t, n, a) {
  this.is(e, OBJECT) && 'h' in e && 's' in e && lStr in e && (n = e.l, t = e.s, e = e.h), (1 < e || 1 < t || 1 < n) && (e /= 360, t /= 100, n /= 100), e *= 360;
  var i, r, o, d, p;
  return e = e % 360 / 60, p = 2 * t * (.5 > n ? n : 1 - n), d = p * (1 - abs(e % 2 - 1)), i = r = o = n - p / 2, e = ~~e, i += [p, d, 0, 0, d, p][e], r += [d, p, p, d, 0, 0][e], o += [0, 0, d, p, p, d][e], packageRGB(i, r, o, a);
}, R.rgb2hsb = function (e, t, n) {
  n = prepareRGB(e, t, n), e = n[0], t = n[1], n = n[2];
  var a, i, o, s;
  return o = mmax(e, t, n), s = o - mmin(e, t, n), a = 0 === s ? null : o === e ? (t - n) / s : o === t ? (n - e) / s + 2 : (e - t) / s + 4, a = 60 * ((a + 360) % 6) / 360, i = 0 === s ? 0 : s / o, {
    h: a,
    s: i,
    b: o,
    toString: hsbtoString
  };
}, R.rgb2hsl = function (e, t, n) {
  n = prepareRGB(e, t, n), e = n[0], t = n[1], n = n[2];
  var a, i, o, s, l, d;
  return s = mmax(e, t, n), l = mmin(e, t, n), d = s - l, a = 0 === d ? null : s === e ? (t - n) / d : s === t ? (n - e) / d + 2 : (e - t) / d + 4, a = 60 * ((a + 360) % 6) / 360, o = (s + l) / 2, i = 0 === d ? 0 : .5 > o ? d / (2 * o) : d / (2 - 2 * o), {
    h: a,
    s: i,
    l: o,
    toString: hsltoString
  };
}, R._path2string = function () {
  return this.join(COMMA).replace(p2s, TOKEN1);
}, R._cacher = cacher;

function clrToString() {
  return this.hex;
}

R.getRGB = cacher(function (e) {
  var n, a, i, r, o, s, l;
  return (e && is(e, OBJECT) && 'opacity' in e && (n = e.opacity), !e || !!((e = Str(e)).indexOf('-') + 1)) ? {
    r: -1,
    g: -1,
    b: -1,
    hex: NONE,
    error: 1,
    toString: clrToString
  } : e === NONE ? {
    r: -1,
    g: -1,
    b: -1,
    hex: NONE,
    toString: clrToString
  } : (hsrg[HAS](e.toLowerCase().substring(0, 2)) || '#' === e.charAt() || (e = _toHex(e)), l = e.match(colourRegExp)) ? (l[2] && (r = toInt(l[2].substring(5), 16), i = toInt(l[2].substring(3, 5), 16), a = toInt(l[2].substring(1, 3), 16)), l[3] && (r = toInt((o = l[3].charAt(3)) + o, 16), i = toInt((o = l[3].charAt(2)) + o, 16), a = toInt((o = l[3].charAt(1)) + o, 16)), l[4] && (s = l[4][SPLIT](commaSpaces), a = toFloat(s[0]), '%' === s[0].slice(-1) && (a *= 2.55), i = toFloat(s[1]), '%' === s[1].slice(-1) && (i *= 2.55), r = toFloat(s[2]), '%' === s[2].slice(-1) && (r *= 2.55), 'rgba' === l[1].toLowerCase().slice(0, 4) && (n = toFloat(s[3])), s[3] && '%' === s[3].slice(-1) && (n /= 100)), l[5]) ? (s = l[5][SPLIT](commaSpaces), a = toFloat(s[0]), '%' === s[0].slice(-1) && (a *= 2.55), i = toFloat(s[1]), '%' === s[1].slice(-1) && (i *= 2.55), r = toFloat(s[2]), '%' === s[2].slice(-1) && (r *= 2.55), ('deg' === s[0].slice(-3) || '\xB0' === s[0].slice(-1)) && (a /= 360), 'hsba' === l[1].toLowerCase().slice(0, 4) && (n = toFloat(s[3])), s[3] && '%' === s[3].slice(-1) && (n /= 100), R.hsb2rgb(a, i, r, n)) : l[6] ? (s = l[6][SPLIT](commaSpaces), a = toFloat(s[0]), '%' === s[0].slice(-1) && (a *= 2.55), i = toFloat(s[1]), '%' === s[1].slice(-1) && (i *= 2.55), r = toFloat(s[2]), '%' === s[2].slice(-1) && (r *= 2.55), ('deg' === s[0].slice(-3) || '\xB0' === s[0].slice(-1)) && (a /= 360), 'hsla' === l[1].toLowerCase().slice(0, 4) && (n = toFloat(s[3])), s[3] && '%' === s[3].slice(-1) && (n /= 100), R.hsl2rgb(a, i, r, n)) : (l = {
    r: a,
    g: i,
    b: r,
    toString: clrToString
  }, l.hex = '#' + (16777216 | r | i << 8 | a << 16).toString(16).slice(1), R.is(n, FINITE) && (l.opacity = n), l) : {
    r: -1,
    g: -1,
    b: -1,
    hex: NONE,
    error: 1,
    toString: clrToString
  };
}, R), R.tintshade = cacher(function (e, t) {
  var n,
      a = R.getRGB(e),
      i = 255;
  return 0 > t && (t *= -1, i = 0), 1 < t && (t = 1), n = 0 === t ? a : {
    r: i - (i - a.r) * t,
    g: i - (i - a.g) * t,
    b: i - (i - a.b) * t,
    toString: clrToString
  }, n.hex = R.rgb(n.r, n.g, n.b), a.error && (n.error = a.error), 'opacity' in a ? (n.rgba = 'rgba(' + [n.r, n.g, n.b, a.opacity].join(',') + ')', n.opacity = a.opacity) : n.rgba = 'rgb(' + [n.r, n.g, n.b].join(',') + ')', n;
}, R), R.rgb = cacher(function (e, t, n) {
  return '#' + (16777216 | n | t << 8 | e << 16).toString(16).slice(1);
});

function catmullRom2bezier(e, t) {
  for (var n, a = [], r = 0, o = e.length; o - 2 * !t > r; r += 2) {
    n = [{
      x: +e[r - 2],
      y: +e[r - 1]
    }, {
      x: +e[r],
      y: +e[r + 1]
    }, {
      x: +e[r + 2],
      y: +e[r + 3]
    }, {
      x: +e[r + 4],
      y: +e[r + 5]
    }], t ? r ? o - 4 == r ? n[3] = {
      x: +e[0],
      y: +e[1]
    } : o - 2 == r && (n[2] = {
      x: +e[0],
      y: +e[1]
    }, n[3] = {
      x: +e[2],
      y: +e[3]
    }) : n[0] = {
      x: +e[o - 2],
      y: +e[o - 1]
    } : o - 4 == r ? n[3] = n[2] : !r && (n[0] = {
      x: +e[r],
      y: +e[r + 1]
    }), a.push(['C', (-n[0].x + 6 * n[1].x + n[2].x) / 6, (-n[0].y + 6 * n[1].y + n[2].y) / 6, (n[1].x + 6 * n[2].x - n[3].x) / 6, (n[1].y + 6 * n[2].y - n[3].y) / 6, n[2].x, n[2].y]);
  }

  return a;
}

R.sanitizePath = function (e) {
  var t;
  return t = e.join ? e.join(COMMA) : e, t = rCheckRegex.test(t) ? R._pathToAbsolute(t) : t.replace(p2s, TOKEN1), t;
}, R.parsePathString = function (e) {
  if (!e || !e.length) return null;
  var t = paths(e);
  if (t.arr) return pathClone(t.arr);
  if (__data = undef, R.is(e, ARRAY)) if (e = Str(e).replace(/,?([A-Z]),?/g, ',$1,').replace(/(^,?)|(,?$)/g, '').replace(/,,?/g, ',').split(','), R.is(e[0], ARRAY)) __data = pathClone(e);else {
    var n,
        a,
        r,
        o = [],
        s = e.length;

    for (__data = [], n = 0; n < s; n += 1) {
      charRegex.test(e[n]) ? (o.length && __data.push(o), a = e[n], o = [a], r = paramCounts[a.toLowerCase()]) : r ? (o.push(+e[n]), r--) : e[n].length && (__data.push(o), o = [a].concat(+e[n]), r = paramCounts[a.toLowerCase()] - 1);
    }

    __data.push(o);
  }
  return __data && __data.length || (__data = [], Str(e).replace(pathCommand, pathStringBreakFn)), __data.toString = R._path2string, t.arr = __data, t.arr;
}, R.parseTransformString = cacher(function (e) {
  if (!e) return null;
  var t = [];
  return R.is(e, ARRAY) && R.is(e[0], ARRAY) && (t = pathClone(e)), t.length || Str(e).replace(tCommand, function (e, n, a) {
    var i = [],
        r = lowerCase.call(n);
    a.replace(pathValues, function (e, t) {
      t && i.push(+t);
    }), t.push([n][CONCAT](i));
  }), t.toString = R._path2string, t;
});
var _pathCache = {},
    paths = cacher(function () {
  return {};
}, undef, undef, undef, 500, _pathCache, !0);

R.findDotsAtSegment = function (e, n, a, i, r, o, s, l, d) {
  var t = 1 - d,
      p = pow(t, 3),
      c = pow(t, 2),
      g = d * d,
      h = g * d,
      u = e + 2 * d * (a - e) + g * (r - 2 * a + e),
      m = n + 2 * d * (i - n) + g * (o - 2 * i + n),
      f = a + 2 * d * (r - a) + g * (s - 2 * r + a),
      y = i + 2 * d * (o - i) + g * (l - 2 * o + i),
      x = 90 - 180 * math.atan2(u - f, m - y) / PI;
  return (u > f || m < y) && (x += 180), {
    x: p * e + 3 * c * d * a + 3 * t * d * d * r + h * s,
    y: p * n + 3 * c * d * i + 3 * t * d * d * o + h * l,
    m: {
      x: u,
      y: m
    },
    n: {
      x: f,
      y: y
    },
    start: {
      x: t * e + d * a,
      y: t * n + d * i
    },
    end: {
      x: t * r + d * s,
      y: t * o + d * l
    },
    alpha: x
  };
};

function base3(e, t, n, a, i) {
  return e * (e * (-3 * t + 9 * n - 9 * a + 3 * i) + 6 * t - 12 * n + 6 * a) - 3 * t + 3 * n;
}

function bezlen(e, t, n, a, r, o, s, l, d) {
  null == d && (d = 1), d = 1 < d ? 1 : 0 > d ? 0 : d;

  for (var p = d / 2, c = [-.1252, .1252, -.3678, .3678, -.5873, .5873, -.7699, .7699, -.9041, .9041, -.9816, .9816], g = [.2491, .2491, .2335, .2335, .2032, .2032, .1601, .1601, .1069, .1069, .0472, .0472], h = 0, u = 0; u < 12; u++) {
    var m = p * c[u] + p,
        f = base3(m, e, n, r, s),
        y = base3(m, t, a, o, l);
    h += g[u] * mathSqrt(f * f + y * y);
  }

  return p * h;
}

function getTatLen(e, t, n, a, i, r, o, s, d) {
  if (!(0 > d || bezlen(e, t, n, a, i, r, o, s) < d)) {
    var p,
        c = 1 / 2,
        g = 1 - c;

    for (p = bezlen(e, t, n, a, i, r, o, s, g); abs(p - d) > .01;) {
      c /= 2, g += (p < d ? 1 : -1) * c, p = bezlen(e, t, n, a, i, r, o, s, g);
    }

    return g;
  }
}

function intersect(e, t, n, a, i, r, o, s) {
  if (!(mmax(e, n) < mmin(i, o) || mmin(e, n) > mmax(i, o) || mmax(t, a) < mmin(r, s) || mmin(t, a) > mmax(r, s))) {
    var l = (e - n) * (r - s) - (t - a) * (i - o);

    if (l) {
      var d = ((e * a - t * n) * (i - o) - (e - n) * (i * s - r * o)) / l,
          p = ((e * a - t * n) * (r - s) - (t - a) * (i * s - r * o)) / l,
          c = +d.toFixed(2),
          g = +p.toFixed(2);
      return c < +mmin(e, n).toFixed(2) || c > +mmax(e, n).toFixed(2) || c < +mmin(i, o).toFixed(2) || c > +mmax(i, o).toFixed(2) || g < +mmin(t, a).toFixed(2) || g > +mmax(t, a).toFixed(2) || g < +mmin(r, s).toFixed(2) || g > +mmax(r, s).toFixed(2) ? void 0 : {
        x: d,
        y: p
      };
    }
  }
}

R._removedFactory = function (e) {
  return function () {
    eve('raphael.log', null, "Rapha\xEBl: you are calling to method \u201C" + e + "\u201D of removed object", e);
  };
};

var pathDimensions = R.pathBBox = function (e) {
  var t = paths(e);
  if (!e) return {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    x2: 0,
    y2: 0
  };
  e = path2curve(e);

  for (var n, a = 0, r = 0, o = [], s = [], l = 0, d = e.length; l < d; l++) {
    if (n = e[l], n[0] === strM) a = n[1], r = n[2], o.push(a), s.push(r);else {
      var c = curveDim(a, r, n[1], n[2], n[3], n[4], n[5], n[6]);
      o = o[CONCAT](c.min.x, c.max.x), s = s[CONCAT](c.min.y, c.max.y), a = n[5], r = n[6];
    }
  }

  var g = mmin[APPLY](0, o),
      h = mmin[APPLY](0, s),
      u = mmax[APPLY](0, o),
      m = mmax[APPLY](0, s),
      f = {
    x: g,
    y: h,
    x2: u,
    y2: m,
    width: u - g,
    height: m - h
  };
  return t.bbox = clone(f), f;
},
    pathClone = function pathClone(e) {
  var t = clone(e);
  return t.toString = R._path2string, t;
},
    pathToAbsolute = R._pathToAbsolute = function (e) {
  var t,
      n = paths(e);

  if (!n.abs) {
    if (R.is(e, ARRAY) && R.is(e && e[0], ARRAY) || (e = R.parsePathString(e)), !e || !e.length) return t = [[strM, 0, 0]], t.toString = R._path2string, t;
    var a = 0,
        o = 0,
        s = 0,
        l = 0,
        d = 0;
    t = [], e[0][0] === strM && (a = +e[0][1], o = +e[0][2], s = a, l = o, d++, t[0] = [strM, a, o]);

    for (var p, c, g = 3 === e.length && e[0][0] === strM && 'R' === e[1][0].toUpperCase() && 'Z' === e[2][0].toUpperCase(), h = d, u = e.length; h < u; h++) {
      if (t.push(p = []), c = e[h], c[0] != upperCase.call(c[0])) switch (p[0] = upperCase.call(c[0]), p[0]) {
        case 'A':
          p[1] = c[1], p[2] = c[2], p[3] = c[3], p[4] = c[4], p[5] = c[5], p[6] = +(c[6] + a), p[7] = +(c[7] + o);
          break;

        case 'V':
          p[1] = +c[1] + o;
          break;

        case 'H':
          p[1] = +c[1] + a;
          break;

        case 'R':
          for (var m = [a, o][CONCAT](c.slice(1)), f = 2, b = m.length; f < b; f++) {
            m[f] = +m[f] + a, m[++f] = +m[f] + o;
          }

          t.pop(), t = t[CONCAT](catmullRom2bezier(m, g));
          break;

        case 'M':
          s = +c[1] + a, l = +c[2] + o;

        default:
          for (f = 1, b = c.length; f < b; f++) {
            p[f] = +c[f] + (f % 2 ? a : o), f % 2 ? a = p[f] : o = p[f];
          }

      } else if ('R' === c[0]) m = [a, o][CONCAT](c.slice(1)), t.pop(), t = t[CONCAT](catmullRom2bezier(m, g)), p = ['R'][CONCAT](c.slice(-2));else for (var v = 0, _ = c.length; v < _; v++) {
        p[v] = c[v];
      }

      switch (p[0]) {
        case 'Z':
          a = s, o = l;
          break;

        case 'H':
          a = p[1];
          break;

        case 'V':
          o = p[1];
          break;

        case 'M':
          s = p[p.length - 2], l = p[p.length - 1];

        default:
          a = p[p.length - 2], o = p[p.length - 1];
      }
    }

    t.toString = R._path2string, n.abs = t;
  }

  return pathClone(n.abs);
},
    l2c = function l2c(e, t, n, a) {
  return [e, t, n, a, n, a];
},
    q2c = function q2c(e, t, n, a, i, r) {
  var o = 1 / 3,
      s = 2 / 3;
  return [o * e + s * n, o * t + s * a, o * i + s * n, o * r + s * a, i, r];
},
    a2c = function a2c(e, n, a, r, o, s, l, d, p, c) {
  l = l && +l, s = s && +s;
  var g,
      u = 120 * PI / 180,
      m = deg2rad * (+o || 0),
      f = [],
      b = cacher(function (e, t, n) {
    var a = e * mathCos(n) - t * mathSin(n),
        i = e * mathSin(n) + t * mathCos(n);
    return {
      x: a,
      y: i
    };
  });

  if (!c) {
    g = b(e, n, -m), e = g.x, n = g.y, g = b(d, p, -m), d = g.x, p = g.y;

    var v = mathCos(deg2rad * o),
        _ = mathSin(deg2rad * o),
        A = (e - d) / 2,
        x = (n - p) / 2,
        y = A * A / (a * a) + x * x / (r * r);

    1 < y && (y = mathSqrt(y), a = y * a, r = y * r);
    var C = a * a,
        T = r * r,
        w = (s === l ? -1 : 1) * mathSqrt(abs((C * T - C * x * x - T * A * A) / (C * x * x + T * A * A))),
        k = w * a * x / r + (e + d) / 2,
        S = w * -r * A / a + (n + p) / 2,
        E = math.asin(((n - S) / r).toFixed(9)),
        P = math.asin(((p - S) / r).toFixed(9));
    E = e < k ? PI - E : E, P = d < k ? PI - P : P, 0 > E && (E = 2 * PI + E), 0 > P && (P = 2 * PI + P), l && E > P && (E -= 2 * PI), !l && P > E && (P -= 2 * PI);
  } else E = c[0], P = c[1], k = c[2], S = c[3];

  var I = P - E;

  if (abs(I) > u) {
    var L = P,
        F = d,
        j = p;
    P = E + u * (l && P > E ? 1 : -1), d = k + a * mathCos(P), p = S + r * mathSin(P), f = a2c(d, p, a, r, o, 0, l, F, j, [P, L, k, S]);
  }

  I = P - E;
  var O = mathCos(E),
      N = mathSin(E),
      B = mathCos(P),
      D = mathSin(P),
      R = math.tan(I / 4),
      t = 4 / 3 * a * R,
      M = 4 / 3 * r * R,
      V = [e, n],
      Y = [e + t * N, n - M * O],
      q = [d + t * D, p - M * B],
      H = [d, p];
  if (Y[0] = 2 * V[0] - Y[0], Y[1] = 2 * V[1] - Y[1], c) return [Y, q, H][CONCAT](f);
  f = [Y, q, H][CONCAT](f).join()[SPLIT](COMMA);

  for (var z = [], X = 0, G = f.length; X < G; X++) {
    z[X] = X % 2 ? b(f[X - 1], f[X], m).y : b(f[X], f[X + 1], m).x;
  }

  return z;
},
    findDotAtSegment = function findDotAtSegment(e, n, a, i, r, o, s, l, d) {
  var t = 1 - d;
  return {
    x: pow(t, 3) * e + 3 * pow(t, 2) * d * a + 3 * t * d * d * r + pow(d, 3) * s,
    y: pow(t, 3) * n + 3 * pow(t, 2) * d * i + 3 * t * d * d * o + pow(d, 3) * l
  };
},
    curveDim = cacher(function (e, t, n, i, r, o, s, l) {
  var d,
      p = r - 2 * n + e - (s - 2 * r + n),
      g = 2 * (n - e) - 2 * (r - n),
      h = e - n,
      u = (-g + mathSqrt(g * g - 4 * p * h)) / 2 / p,
      m = (-g - mathSqrt(g * g - 4 * p * h)) / 2 / p,
      f = [t, l],
      y = [e, s];
  return '1e12' < abs(u) && (u = .5), '1e12' < abs(m) && (m = .5), 0 < u && 1 > u && (d = findDotAtSegment(e, t, n, i, r, o, s, l, u), y.push(d.x), f.push(d.y)), 0 < m && 1 > m && (d = findDotAtSegment(e, t, n, i, r, o, s, l, m), y.push(d.x), f.push(d.y)), p = o - 2 * i + t - (l - 2 * o + i), g = 2 * (i - t) - 2 * (o - i), h = t - i, u = (-g + mathSqrt(g * g - 4 * p * h)) / 2 / p, m = (-g - mathSqrt(g * g - 4 * p * h)) / 2 / p, '1e12' < abs(u) && (u = .5), '1e12' < abs(m) && (m = .5), 0 < u && 1 > u && (d = findDotAtSegment(e, t, n, i, r, o, s, l, u), y.push(d.x), f.push(d.y)), 0 < m && 1 > m && (d = findDotAtSegment(e, t, n, i, r, o, s, l, m), y.push(d.x), f.push(d.y)), {
    min: {
      x: mmin[APPLY](0, y),
      y: mmin[APPLY](0, f)
    },
    max: {
      x: mmax[APPLY](0, y),
      y: mmax[APPLY](0, f)
    }
  };
}),
    path2curve = R._path2curve = cacher(function (e, t) {
  var n = !t && paths(e);
  if (!t && n.curve) return pathClone(n.curve);

  for (var a = pathToAbsolute(e), r = t && pathToAbsolute(t), o = {
    x: 0,
    y: 0,
    bx: 0,
    by: 0,
    X: 0,
    Y: 0,
    qx: null,
    qy: null
  }, s = {
    x: 0,
    y: 0,
    bx: 0,
    by: 0,
    X: 0,
    Y: 0,
    qx: null,
    qy: null
  }, l = function l(e, t) {
    var n, a;
    if (!e) return ['C', t.x, t.y, t.x, t.y, t.x, t.y];

    switch ((e[0] in {
      T: 1,
      Q: 1
    }) || (t.qx = t.qy = null), e[0]) {
      case 'M':
        t.X = e[1], t.Y = e[2];
        break;

      case 'A':
        e = ['C'][CONCAT](a2c[APPLY](0, [t.x, t.y][CONCAT](e.slice(1))));
        break;

      case 'S':
        n = t.x + (t.x - (t.bx || t.x)), a = t.y + (t.y - (t.by || t.y)), e = ['C', n, a][CONCAT](e.slice(1));
        break;

      case 'T':
        t.qx = t.x + (t.x - (t.qx || t.x)), t.qy = t.y + (t.y - (t.qy || t.y)), e = ['C'][CONCAT](q2c(t.x, t.y, t.qx, t.qy, e[1], e[2]));
        break;

      case 'Q':
        t.qx = e[1], t.qy = e[2], e = ['C'][CONCAT](q2c(t.x, t.y, e[1], e[2], e[3], e[4]));
        break;

      case 'L':
        e = ['C'][CONCAT](l2c(t.x, t.y, e[1], e[2]));
        break;

      case 'H':
        e = ['C'][CONCAT](l2c(t.x, t.y, e[1], t.y));
        break;

      case 'V':
        e = ['C'][CONCAT](l2c(t.x, t.y, t.x, e[1]));
        break;

      case 'Z':
        e = ['C'][CONCAT](l2c(t.x, t.y, t.X, t.Y));
    }

    return e;
  }, d = function d(e, t) {
    if (7 < e[t].length) {
      e[t].shift();

      for (var n = e[t]; n.length;) {
        e.splice(t++, 0, ['C'][CONCAT](n.splice(0, 6)));
      }

      e.splice(t, 1), g = mmax(a.length, r && r.length || 0);
    }
  }, p = function p(e, t, n, o, s) {
    e && t && e[s][0] === strM && t[s][0] != strM && !s && (t.splice(s, 0, [strM, o.x, o.y]), n.bx = 0, n.by = 0, n.x = e[s][1], n.y = e[s][2], g = mmax(a.length, r && r.length || 0));
  }, c = 0, g = mmax(a.length, r && r.length || 0); c < g; c++) {
    a[c] = l(a[c], o), d(a, c), r && (r[c] = l(r[c], s)), r && d(r, c), p(a, r, o, s, c), p(r, a, s, o, c);
    var h = a[c],
        u = r && r[c],
        m = h.length,
        f = r && u.length;
    o.x = h[m - 2], o.y = h[m - 1], o.bx = toFloat(h[m - 4]) || o.x, o.by = toFloat(h[m - 3]) || o.y, s.bx = r && (toFloat(u[f - 4]) || s.x), s.by = r && (toFloat(u[f - 3]) || s.y), s.x = r && u[f - 2], s.y = r && u[f - 1];
  }

  return r || (n.curve = pathClone(a)), r ? [a, r] : a;
}, null, pathClone),
    parseDots = R._parseDots = cacher(function (e) {
  for (var t = [], n = 0, a = e.length; n < a; n++) {
    var r = {},
        o = e[n].match(/^([^:]*):?([\d\.]*)/);
    if (r.color = R.getRGB(o[1]), r.color.error) return null;
    r.opacity = r.color.opacity, r.color = r.color.hex, o[2] && (r.offset = o[2] + '%'), t.push(r);
  }

  for (n = 1, a = t.length - 1; n < a; n++) {
    if (!t[n].offset) {
      for (var s = toFloat(t[n - 1].offset || 0), l = 0, p = n + 1; p < a; p++) {
        if (t[p].offset) {
          l = t[p].offset;
          break;
        }
      }

      l || (l = 100, p = a), l = toFloat(l);

      for (var c = (l - s) / (p - n + 1); n < p; n++) {
        s += c, t[n].offset = s + '%';
      }
    }
  }

  return t;
}),
    tear = R._tear = function (e, t) {
  e === t.top && (t.top = e.prev), e === t.bottom && (t.bottom = e.next), e.next && (e.next.prev = e.prev), e.prev && (e.prev.next = e.next);
},
    tofront = R._tofront = function (e, t) {
  return t.top !== e && (tear(e, t), e.next = null, e.prev = t.top, t.top.next = e, t.top = e, !0);
},
    toback = R._toback = function (e, t) {
  return t.bottom !== e && (tear(e, t), e.next = t.bottom, e.prev = null, t.bottom.prev = e, t.bottom = e, !0);
},
    insertafter = R._insertafter = function (e, t, n, a) {
  tear(e, n), e.parent = a, t === a.top && (a.top = e), t.next && (t.next.prev = e), e.next = t.next, e.prev = t, t.next = e;
},
    insertbefore = R._insertbefore = function (e, t, n, a) {
  tear(e, n), e.parent = a, t === a.bottom && (a.bottom = e), t.prev && (t.prev.next = e), e.prev = t.prev, t.prev = e, e.next = t;
},
    extractTransform = R._extractTransform = function (e, n) {
  if (null == n) return e._.transform;
  n = Str(n).replace(/\.{3}|\u2026/g, e._.transform || E);
  var a = R.parseTransformString(n),
      r = 0,
      o = 0,
      s = 0,
      l = 1,
      d = 1,
      p = e._,
      c = new Matrix();
  if (p.transform = a || [], a) for (var g = 0, h = a.length; g < h; g++) {
    var u,
        m,
        f,
        y,
        x,
        b = a[g],
        t = b.length,
        v = Str(b[0]).toLowerCase(),
        _ = b[0] != v,
        A = _ ? c.invert() : 0;

    't' === v && 3 === t ? _ ? (u = A.x(0, 0), m = A.y(0, 0), f = A.x(b[1], b[2]), y = A.y(b[1], b[2]), c.translate(f - u, y - m)) : c.translate(b[1], b[2]) : 'r' === v ? 2 === t ? (x = p.bb || (p.bb = e.getBBox(1)), c.rotate(b[1], x.x + x.width / 2, x.y + x.height / 2), r += b[1]) : 4 === t && (_ ? (f = A.x(b[2], b[3]), y = A.y(b[2], b[3]), c.rotate(b[1], f, y)) : c.rotate(b[1], b[2], b[3]), r += b[1]) : 's' === v ? 2 === t || 3 === t ? (x = p.bb || (p.bb = e.getBBox(1)), c.scale(b[1], b[t - 1], x.x + x.width / 2, x.y + x.height / 2), l *= b[1], d *= b[t - 1]) : 5 === t && (_ ? (f = A.x(b[3], b[4]), y = A.y(b[3], b[4]), c.scale(b[1], b[2], f, y)) : c.scale(b[1], b[2], b[3], b[4]), l *= b[1], d *= b[2]) : v === mStr && 7 === t && c.add(b[1], b[2], b[3], b[4], b[5], b[6]), p.dirtyT = 1, e.matrix = c;
  }
  e.matrix = c, p.sx = l, p.sy = d, p.deg = r, p.dx = o = c.e, p.dy = s = c.f, 1 === l && 1 === d && !r && p.bbox ? (p.bbox.x += +o, p.bbox.y += +s) : p.dirtyT = 1;
},
    getEmpty = function getEmpty(e) {
  var t = e[0];

  switch (t.toLowerCase()) {
    case 't':
      return [t, 0, 0];

    case 'm':
      return [t, 1, 0, 0, 1, 0, 0];

    case 'r':
      return 4 === e.length ? [t, 0, e[2], e[3]] : [t, 0];

    case 's':
      return 5 === e.length ? [t, 1, 1, e[3], e[4]] : 3 === e.length ? [t, 1, 1] : [t, 1];
  }
},
    equaliseTransform = R._equaliseTransform = function (e, t) {
  t = Str(t).replace(/\.{3}|\u2026/g, e), e = R.parseTransformString(e) || [], t = R.parseTransformString(t) || [];

  for (var n, a, r, o, s = mmax(e.length, t.length), l = [], d = [], p = 0; p < s; p++) {
    if (r = e[p] || getEmpty(t[p]), o = t[p] || getEmpty(r), r[0] != o[0] || 'r' === r[0].toLowerCase() && (r[2] != o[2] || r[3] != o[3]) || 's' === r[0].toLowerCase() && (r[3] != o[3] || r[4] != o[4])) return;

    for (l[p] = [], d[p] = [], (n = 0, a = mmax(r.length, o.length)); n < a; n++) {
      n in r && (l[p][n] = r[n]), n in o && (d[p][n] = o[n]);
    }
  }

  return {
    from: l,
    to: d
  };
};

R._getContainer = function (e, t, n, a) {
  var i;
  return i = null != a || R.is(e, OBJECT) ? e : g.doc.getElementById(e), null == i ? void 0 : i.tagName ? null == t ? {
    container: i,
    width: i.style.pixelWidth || i.offsetWidth,
    height: i.style.pixelHeight || i.offsetHeight
  } : {
    container: i,
    width: t,
    height: n
  } : {
    container: 1,
    x: e,
    y: t,
    width: n,
    height: a
  };
}, R._engine = {}, R.path2curve = path2curve, R.matrix = function (t, n, a, i, r, e) {
  return new Matrix(t, n, a, i, r, e);
};

function Matrix(t, n, a, i, r, e) {
  null == t ? (this.a = 1, this.b = 0, this.c = 0, this.d = 1, this.e = 0, this.f = 0) : (this.a = +t, this.b = +n, this.c = +a, this.d = +i, this.e = +r, this.f = +e);
}

(function (e) {
  function t(e) {
    return e[0] * e[0] + e[1] * e[1];
  }

  function n(e) {
    var n = mathSqrt(t(e));
    e[0] && (e[0] /= n), e[1] && (e[1] /= n);
  }

  e.add = function (t, n, a, i, r, e) {
    var o,
        s,
        l,
        d,
        p = [[], [], []],
        c = [[this.a, this.c, this.e], [this.b, this.d, this.f], [0, 0, 1]],
        g = [[t, a, r], [n, i, e], [0, 0, 1]];

    for (t && t instanceof Matrix && (g = [[t.a, t.c, t.e], [t.b, t.d, t.f], [0, 0, 1]]), o = 0; 3 > o; o++) {
      for (s = 0; 3 > s; s++) {
        for (d = 0, l = 0; 3 > l; l++) {
          d += c[o][l] * g[l][s];
        }

        p[o][s] = d;
      }
    }

    this.a = p[0][0], this.b = p[1][0], this.c = p[0][1], this.d = p[1][1], this.e = p[0][2], this.f = p[1][2];
  }, e.invert = function () {
    var e = this,
        t = e.a * e.d - e.b * e.c;
    return new Matrix(e.d / t, -e.b / t, -e.c / t, e.a / t, (e.c * e.f - e.d * e.e) / t, (e.b * e.e - e.a * e.f) / t);
  }, e.clone = function () {
    return new Matrix(this.a, this.b, this.c, this.d, this.e, this.f);
  }, e.translate = function (e, t) {
    this.add(1, 0, 0, 1, e, t);
  }, e.scale = function (e, t, n, a) {
    null == t && (t = e), (n || a) && this.add(1, 0, 0, 1, n, a), this.add(e, 0, 0, t, 0, 0), (n || a) && this.add(1, 0, 0, 1, -n, -a);
  }, e.rotate = function (e, t, n) {
    e = R.rad(e), t = t || 0, n = n || 0;
    var i = +mathCos(e).toFixed(9),
        r = +mathSin(e).toFixed(9);
    this.add(i, r, -r, i, t, n), this.add(1, 0, 0, 1, -t, -n);
  }, e.x = function (e, t) {
    return e * this.a + t * this.c + this.e;
  }, e.y = function (e, t) {
    return e * this.b + t * this.d + this.f;
  }, e.get = function (e) {
    return +this[Str.fromCharCode(97 + e)].toFixed(4);
  }, e.toString = function () {
    return R.svg ? 'matrix(' + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)].join() + ')' : [this.get(0), this.get(2), this.get(1), this.get(3), 0, 0].join();
  }, e.toMatrixString = function () {
    return 'matrix(' + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)].join() + ')';
  }, e.toFilter = function () {
    return 'progid:DXImageTransform.Microsoft.Matrix(M11=' + this.get(0) + ', M12=' + this.get(2) + ', M21=' + this.get(1) + ', M22=' + this.get(3) + ', Dx=' + this.get(4) + ', Dy=' + this.get(5) + ', sizingmethod=\'auto expand\')';
  }, e.offset = function () {
    return [this.e.toFixed(4), this.f.toFixed(4)];
  }, e.split = function () {
    var e = {
      dx: this.e,
      dy: this.f
    },
        a = [[this.a, this.c], [this.b, this.d]];
    e.scalex = mathSqrt(t(a[0])), n(a[0]), e.shear = a[0][0] * a[1][0] + a[0][1] * a[1][1], a[1] = [a[1][0] - a[0][0] * e.shear, a[1][1] - a[0][1] * e.shear], e.scaley = mathSqrt(t(a[1])), n(a[1]), e.shear /= e.scaley;
    var i = -a[0][1],
        r = a[1][1];
    return 0 > r ? (e.rotate = R.deg(math.acos(r)), 0 > i && (e.rotate = 360 - e.rotate)) : e.rotate = R.deg(math.asin(i)), e.isSimple = !+e.shear.toFixed(9) && (e.scalex.toFixed(9) === e.scaley.toFixed(9) || !e.rotate), e.isSuperSimple = !+e.shear.toFixed(9) && e.scalex.toFixed(9) === e.scaley.toFixed(9) && !e.rotate, e.noRotation = !+e.shear.toFixed(9) && !e.rotate, e;
  }, e.toTransformString = function (e) {
    var t = e || this[SPLIT]();
    return t.isSimple ? (t.scalex = +t.scalex.toFixed(4), t.scaley = +t.scaley.toFixed(4), t.rotate = +t.rotate.toFixed(4), (t.dx || t.dy ? 't' + [t.dx, t.dy] : E) + (1 != t.scalex || 1 != t.scaley ? 's' + [t.scalex, t.scaley, 0, 0] : E) + (t.rotate ? 'r' + [t.rotate, 0, 0] : E)) : mStr + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)];
  };
})(Matrix.prototype);

var navigator = win.navigator,
    version = navigator.userAgent.match(/Version\/(.*?)\s/) || navigator.userAgent.match(/Chrome\/(\d+)/);
paperproto.safari = 'Apple Computer, Inc.' === navigator.vendor && (version && 4 > version[1] || 'iP' === navigator.platform.slice(0, 2)) || 'Google Inc.' === navigator.vendor && version && 8 > version[1] ? function () {
  var e = this.rect(-99, -99, this.width + 99, this.height + 99).attr({
    stroke: NONE
  });
  return setTimeout(function () {
    e.remove();
  }), !0;
} : fun;

for (var preventDefault = function preventDefault() {
  this.returnValue = !1;
}, preventTouch = function preventTouch() {
  return this.originalEvent.preventDefault();
}, stopPropagation = function stopPropagation() {
  this.cancelBubble = !0;
}, stopTouch = function stopTouch() {
  return this.originalEvent.stopPropagation();
}, eventCopyList = {
  stopPropagation: 'fn',
  stopImmediatePropagation: 'fn',
  preventDefault: 'fn',
  type: !0,
  clientX: !0,
  clientY: !0,
  pageX: !0,
  pageY: !0,
  bubbles: !0,
  cancelable: !0,
  touches: !0,
  target: !0,
  originalTarget: !0,
  srcElement: !0,
  relatedTarget: !0,
  fromElement: !0,
  changedTouches: !0,
  layerX: !0,
  layerY: !0,
  deltaX: !0,
  deltaY: !0
}, makeSelectiveCopy = R.makeSelectiveCopy = function (e, t) {
  var _loop = function _loop(n) {
    e[n] = 'fn' === eventCopyList[n] ? function () {
      return function () {
        t[n]();
      };
    }(t) : t[n];
  };

  for (var n in eventCopyList) {
    _loop(n);
  }

  e.originalEvent = t, e.type || (e.type = t.originalEvent && t.originalEvent.type);
}, addEvent = R.addEvent = function () {
  if (g.doc.addEventListener) return function (t, n, a, r) {
    var e,
        i,
        o = supportsPointer ? safePointerEventMapping[n] : supportsTouch ? touchMap[n] : n;
    return isIE || (i = {
      capture: !1
    }), r.dragFn && ('pointerup' === o ? o = 'mouseup' : o === UNDEF && (o = 'touchend')), e = function e(o) {
      var s,
          l = g.doc.documentElement.scrollTop || g.doc.body.scrollTop,
          d = g.doc.documentElement.scrollLeft || g.doc.body.scrollLeft;
      if (supportsTouch && touchMap[n]) for (var p = 0, c = o.targetTouches && o.targetTouches.length; p < c; p++) {
        if (s = o.targetTouches[p].target, s === t || 'tspan' === s.nodeName && s.parentNode === t) {
          var h = o;
          o = o.targetTouches[p], o.originalEvent = h, o.preventDefault = preventTouch, o.stopPropagation = stopTouch;
          break;
        }
      }
      return a.call(r, o, o.clientX + d, o.clientY + l);
    }, t.addEventListener(o, e, i), function () {
      return t.removeEventListener(o, e, i), !0;
    };
  };
  return g.doc.attachEvent ? function (e, t, n, a) {
    var i = function i(t) {
      t = t || g.win.event;
      var i = g.doc.documentElement.scrollTop || g.doc.body.scrollTop,
          r = g.doc.documentElement.scrollLeft || g.doc.body.scrollLeft,
          o = t.clientX + r,
          s = t.clientY + i;
      return t.preventDefault = t.preventDefault || preventDefault, t.stopPropagation = t.stopPropagation || stopPropagation, n.call(a, t, o, s);
    };

    e.attachEvent('on' + t, i);
    return function () {
      return e.detachEvent('on' + t, i), !0;
    };
  } : void 0;
}(), dragMove = function dragMove(t) {
  var e,
      n = Math.abs,
      a = g.doc.documentElement.scrollTop || g.doc.body.scrollTop,
      r = g.doc.documentElement.scrollLeft || g.doc.body.scrollLeft,
      o = (t.clientX === UNDEF ? t.changedTouches && t.changedTouches[0].clientX : t.clientX) + r,
      s = (t.clientY === UNDEF ? t.changedTouches && t.changedTouches[0].clientY : t.clientY) + a,
      l = {},
      d = this,
      p = d.dragInfo.onmove.length;
  if (!(d.dragStartFn && !(2.5 <= n(o - d._drag.x) || 2.5 <= n(s - d._drag.y)) || d._blockDrag || supportsPointer && supportsTouch && !t.isPrimary)) for (; p--;) {
    if (supportsTouch && 'touchmove' === t.type) for (var c, h = t.touches.length; h--;) {
      if (c = t.touches[h], c.identifier === d._drag.id) {
        o = c.clientX + r, s = c.clientY + a;
        break;
      }
    }

    if (!d.removed) {
      if (d.dragStartFn && (d.dragStartFn(p), d.dragStartFn = void 0, d.dragInfo._dragmove = !0), g.win.opera) {
        var u = R._engine.getNode(d),
            m = u.nextSibling,
            f = u.parentNode,
            b = u.style.display;

        f.removeChild(u), u.style.display = NONE, u.style.display = b, m ? f.insertBefore(u, m) : f.appendChild(u);
      }

      makeSelectiveCopy(l, t), e = l.data = [o - d._drag.x, s - d._drag.y, o, s], eve('raphael.drag.move.' + d.id, d.dragInfo.move_scope[p] || d, l, e);
    }
  }
}, dragUp = function dragUp(t) {
  var e = this,
      n = e.dragInfo,
      a = n.onend.length;
  if (e.dragInfo._dragmove) for (; a--;) {
    e._drag = {}, eve('raphael.drag.end.' + e.id, n.end_scope[a] || n.start_scope[a] || n.move_scope[a] || e, t);
  }
  e.dragInfo._dragmove = void 0, !supportsTouch || isIE11 || isEdge || isWindows && isFirefox || (e.paper.canvas.style['touch-action'] = 'auto'), R.undragmove.call(e, dragMove), R.undragend.call(e, dragUp), R.unmousemove.call(e, dragMove).unmouseup.call(e, dragUp);
}, elproto = R.el = {}, i = events.length; i--;) {
  (function (e) {
    R[e] = elproto[e] = function (t, n, a) {
      return R.is(t, FUNCTION) && (this.events = this.events || [], this.events.push({
        name: e,
        f: t,
        unbind: addEvent(a || this.shape || this.node || g.doc, e, t, n || this)
      })), this;
    }, R['un' + e] = elproto['un' + e] = function (t) {
      for (var n = this.events || [], a = n.length; a--;) {
        if (n[a].name === e && n[a].f === t) return n[a].unbind(), n.splice(a, 1), n.length || delete this.events, this;
      }

      return this;
    };
  })(events[i]);
}

elproto.data = function (e, t) {
  var n = eldata[this.id] = eldata[this.id] || {};

  if (1 === arguments.length) {
    if (R.is(e, OBJECT)) {
      for (var a in e) {
        e[HAS](a) && this.data(a, e[a]);
      }

      return this;
    }

    return R.stopPartialEventPropagation || eve('raphael.data.get.' + this.id, this, n[e], e), n[e];
  }

  return n[e] = t, R.stopPartialEventPropagation || eve('raphael.data.set.' + this.id, this, t, e), this;
}, elproto.removeData = function (e) {
  return null == e ? delete eldata[this.id] : eldata[this.id] && delete eldata[this.id][e], this;
}, elproto.dbclick = function (t, n) {
  var e,
      a = this,
      i = function i(e) {
    return !e.touches || e.touches && 1 === e.touches.length;
  },
      r = function r(_r) {
    (!supportsPointer || _r.isPrimary) && (_r && _r.preventDefault(), i(_r) && (a._tappedOnce ? (t.call(n || a, _r), a._tappedOnce = !1) : (a._tappedOnce = !0, setTimeout(function () {
      a._tappedOnce = !1;
    }, 500))));
  };

  e = supportsPointer ? 'pointerup' : R.supportsTouch ? 'touchstart' : 'mouseup', a.node.addEventListener(e, r), R.storeHandlers(a, t, r);
}, elproto.undbclick = function (e) {
  var t = this,
      n = removeHandlers(t, e);
  n && t.node.removeEventListener(supportsPointer ? 'pointerup' : R.supportsTouch ? 'touchstart' : 'mouseup', n);
}, elproto.getData = function () {
  return clone(eldata[this.id] || {});
};

var downables = [],
    mouseDown = function mouseDown() {
  this.untrack = addEvent(g.doc, 'mouseup', mouseUp, this);
},
    mouseUp = function mouseUp() {
  return this.untrack(), this.untrack = null, this.fn && this.fn.apply(this.scope || this.el, arguments);
};

elproto.mouseup = function (e, t, n, a) {
  return n ? (downables.push(n = {
    el: this,
    fn: e,
    scope: t
  }), n.unbind = addEvent(this.shape || this.node || g.doc, 'mousedown', mouseDown, n), this) : R.mouseup.apply(this, [e, t, a]);
}, elproto.unmouseup = function (e) {
  for (var t, n = downables.length; n--;) {
    downables[n].el === this && downables[n].fn === e && (t = downables[n], t.unbind(), t.untrack && t.untrack(), downables.splice(n, 1));
  }

  return t ? this : R.unmouseup.apply(this, arguments);
}, elproto.hover = function (e, t, n, a) {
  return this.on('fc-mouseover', e, n).on('fc-mouseout', t, a);
}, elproto.unhover = function (e, t) {
  return this.off('fc-mouseover', e).off('fc-mouseout', t);
}, elproto.fcclick = function (t, n) {
  var e,
      a,
      i,
      r,
      o,
      s = Math.abs,
      l = this,
      d = l.node,
      p = function p(t) {
    l._lastEventTriggered = 'mousedown', i = t.clientX === UNDEF ? t.changedTouches && t.changedTouches[0].clientX : t.clientX, r = t.clientY === UNDEF ? t.changedTouches && t.changedTouches[0].clientY : t.clientY;
  },
      c = function c(t) {
    var e = t.clientX === UNDEF ? t.changedTouches && t.changedTouches[0].clientX : t.clientX,
        n = t.clientY === UNDEF ? t.changedTouches && t.changedTouches[0].clientY : t.clientY;
    (2.5 <= s(i - e) || 2.5 <= s(r - n)) && (l._lastEventTriggered = void 0);
  };

  if (l._clickStoreActual || (l._clickStoreActual = []), l._clickStoreDerived || (l._clickStoreDerived = []), !l._clickHandlerHelper) {
    for (e in o = !supportsPointer && R.supportsTouch ? {
      touchstart: function touchstart() {
        l._lastEventTriggered = 'touchstart', l._lastEventTriggeredAt = new Date().getTime();
      },
      touchmove: c
    } : supportsPointer && R.supportsTouch ? {
      pointerdown: p,
      pointermove: c
    } : {
      mousedown: p,
      mousemove: c
    }, o) {
      d.addEventListener ? d.addEventListener(e, o[e]) : d.attachEvent('on' + e, o[e]);
    }

    l._clickHandlerHelper = o;
  }

  return !supportsPointer && R.supportsTouch ? (e = 'touchend', a = function a(_a) {
    'touchstart' === l._lastEventTriggered && 500 >= new Date().getTime() - l._lastEventTriggeredAt && setTimeout(function () {
      t.call(n || l, _a);
    }, 0);
  }) : (e = 'click', a = function a(_a2) {
    'mousedown' === l._lastEventTriggered && t.call(n || l, _a2);
  }), d.addEventListener ? d.addEventListener(e, a) : d.attachEvent('on' + e, a), l._clickStoreDerived.push(a), l._clickStoreActual.push(t), l;
}, elproto.fcunclick = function (e) {
  var t,
      n,
      a = this,
      r = a.node,
      o = a._clickHandlerHelper,
      s = a._clickStoreActual,
      l = a._clickStoreDerived;

  if (s) {
    for (t = s.length - 1; 0 <= t; t--) {
      s[t] === e && (r.removeEventListener ? r.removeEventListener(!supportsPointer && R.supportsTouch ? 'touchend' : 'click', l[t]) : r.detachEvent('onclick', l[t]), s.splice(t, 1), l.splice(t, 1));
    }

    if (!s.length) {
      for (n in o) {
        r.removeEventListener ? r.removeEventListener(n, o[n]) : r.detachEvent('on' + n, o[n]);
      }

      a._clickHandlerHelper = void 0;
    }
  }

  return a;
};
var draggable = [];
elproto.drag = function (e, t, n, a, i, r) {
  var o = this,
      s = o.dragInfo || (o.dragInfo = {
    onmove: [],
    onstart: [],
    onend: [],
    move_scope: [],
    start_scope: [],
    end_scope: []
  });
  return e && s.onmove.push(e) && s.move_scope.push(a), t && s.onstart.push(t) && s.start_scope.push(i), n && s.onend.push(n) && s.end_scope.push(r), o.dragFn = o.dragFn || function (t) {
    var e,
        n,
        a,
        r,
        s,
        l,
        d,
        p,
        c,
        h,
        u = g.doc.documentElement.scrollTop || g.doc.body.scrollTop,
        m = g.doc.documentElement.scrollLeft || g.doc.body.scrollLeft,
        f = {},
        y = o.dragInfo,
        x = [dragMove, undef, g.doc];

    if (!supportsPointer || t.isPrimary) {
      for (supportsTouch && (supportsPointer ? !(isIE11 || isEdge) && !(isWindows && isFirefox) && (o.paper.canvas.style['touch-action'] = 'none') : t.preventDefault()), o._drag.x = c = (t.clientX === UNDEF ? t.changedTouches && t.changedTouches[0].clientX : t.clientX) + m, o._drag.y = h = (t.clientY === UNDEF ? t.changedTouches && t.changedTouches[0].clientY : t.clientY) + u, o._drag.id = t.identifier, supportsTouch && !supportsPointer ? R.dragmove.apply(o, x) : R.mousemove.apply(o, x).mouseup.call(o, dragUp, undef, undef, g.doc), supportsTouch && R.dragend.call(o, dragUp, undef, g.doc), makeSelectiveCopy(f, t), e = f.data = [c, h], (n = 0, s = y.onstart.length); n < s; n++) {
        eve.on('raphael.drag.start.' + o.id, y.onstart[n]);
      }

      for (a = 0, l = y.onmove.length; a < l; a++) {
        eve.on('raphael.drag.move.' + o.id, y.onmove[a]);
      }

      for (r = 0, d = y.onend.length; r < d; r++) {
        eve.on('raphael.drag.end.' + o.id, y.onend[r]);
      }

      s && !l && (p = function p() {
        o.undragmove(), y.onmove = [];
      }, y.onmove.push(p), eve.on('raphael.drag.end.' + o.id, p)), o.dragStartFn = function (t) {
        eve('raphael.drag.start.' + o.id, o.dragInfo.start_scope[t] || o.dragInfo.move_scope[t] || o, f, e);
      };
    }
  }, o._drag = {}, draggable.push({
    el: o,
    start: o.dragFn,
    onstart: t,
    onmove: e,
    onend: n
  }), t && !o.startHandlerAttached && (supportsTouch && !supportsPointer ? o.dragstart(o.dragFn) : o.mousedown(o.dragFn), o.startHandlerAttached = !0), o;
}, elproto.onDragOver = function (e) {
  e ? eve.on('raphael.drag.over.' + this.id, e) : eve.unbind('raphael.drag.over.' + this.id);
}, elproto.undrag = function () {
  for (var e = this, t = draggable.length; t--;) {
    draggable[t].el === e && (e.unmousedown(e.dragFn), draggable.splice(t, 1), eve.unbind('raphael.drag.*.' + e.id), e.dragInfo = void 0, e.dragFn = void 0, e.startHandlerAttached = void 0);
  }

  R.unmousemove.call(e, dragMove).unmouseup.call(e, dragUp), R.undragmove.call(e, dragMove), R.undragend.call(e, dragUp), delete e._drag;
}, elproto.undragstart = function (e) {
  var t,
      n,
      a = this,
      r = a.dragInfo,
      o = r && r.onstart,
      s = r && r.start_scope;
  if (e) for (t = 0, n = o && o.length; t < n; t++) {
    if (o[t] === e) {
      o.splice(t, 1), s.splice(t, 1), eve.unbind('raphael.drag.start.' + this.id, e);
      break;
    }
  }
  o && o.length && e || (R.undragstart.call(a, a.dragFn), R.unmousedown.call(a, a.dragFn), eve.unbind('raphael.drag.start.' + this.id), a.startHandlerAttached = !1, r && (r.onstart = [], r.start_scope = []));
}, elproto.undragmove = function (e) {
  var t,
      n,
      a = this,
      r = a.dragInfo,
      o = r && r.onmove,
      s = r && r.move_scope;
  if (e) for (t = 0, n = o && o.length; t < n; t++) {
    if (o[t] === e) {
      o.splice(t, 1), s.splice(t, 1), eve.unbind('raphael.drag.move.' + this.id, e);
      break;
    }
  }
  o && o.length && e || (R.undragmove.call(a, dragMove), R.unmousemove.call(a, dragMove), r && (r.onmove = [], r.move_scope = []), eve.unbind('raphael.drag.move.' + this.id));
}, elproto.undragend = function (e) {
  var t,
      n,
      a = this,
      r = a.dragInfo,
      o = r && r.onend,
      s = r && r.end_scope;
  if (e) for (t = 0, n = o && o.length; t < n; t++) {
    if (o[t] === e) {
      o.splice(t, 1), s.splice(t, 1), eve.unbind('raphael.drag.end.' + this.id, e);
      break;
    }
  }
  o && o.length && e || (R.undragend.call(a, dragUp), R.unmouseup.call(a, dragUp), r && (r.onend = [], r.end_scope = []), eve.unbind('raphael.drag.end.' + this.id));
}, elproto.follow = function (e, t, n) {
  return e.removed || e.constructor !== R.el.constructor ? this : (e.followers.push({
    el: this,
    stalk: n = {
      before: 'insertBefore',
      after: 'insertAfter'
    }[n],
    cb: t
  }), n && this[n](e), this);
}, elproto.unfollow = function (e) {
  if (e.removed || e.constructor !== R.el.constructor) return this;

  for (var t = 0, n = e.followers.length; t < n; t++) {
    if (e.followers[t].el === this) {
      e.followers.splice(t, 1);
      break;
    }
  }

  return this;
}, paperproto.hide = function () {
  var e = this;
  return e.canvas.style.visibility = 'hidden', e;
}, paperproto.show = function () {
  var e = this;
  return e.canvas.style.visibility = E, e;
}, paperproto.group = function () {
  var e = this,
      t = getArrayCopy(arguments),
      n = lastArgIfGroup(t, !0),
      a = R._engine.group(e, t[0], n);

  return e.__set__ && e.__set__.push(a), e._elementsById[a.id] = a;
}, paperproto.circle = function () {
  var e = this,
      t = getArrayCopy(arguments),
      n = lastArgIfGroup(t, !0),
      a = e._addDefAttribs() ? serializeArgs(t, 'cx', 0, 'cy', 0, 'r', 0, 'fill', NONE, 'stroke', BLACK) : serializeArgs(t),
      i = R._engine.circle(e, a, n);

  return e.__set__ && e.__set__.push(i), e._elementsById[i.id] = i;
}, paperproto.rect = function () {
  var e = this,
      t = getArrayCopy(arguments),
      n = lastArgIfGroup(t, !0),
      a = e._addDefAttribs() ? serializeArgs(t, 'x', 0, 'y', 0, 'width', 0, 'height', 0, 'r', 0, 'fill', NONE, 'stroke', BLACK) : serializeArgs(t),
      i = R._engine.rect(e, a, n);

  return e.__set__ && e.__set__.push(i), e._elementsById[i.id] = i;
}, paperproto.ellipse = function () {
  var e = this,
      t = getArrayCopy(arguments),
      n = lastArgIfGroup(t, !0),
      a = e._addDefAttribs() ? serializeArgs(t, 'x', 0, 'y', 0, 'rx', 0, 'ry', 0, 'fill', NONE, 'stroke', BLACK) : serializeArgs(t),
      i = R._engine.ellipse(this, a, n);

  return e.__set__ && e.__set__.push(i), e._elementsById[i.id] = i;
}, paperproto.path = function () {
  var e = this,
      t = getArrayCopy(arguments),
      n = lastArgIfGroup(t, !0),
      a = e.config,
      i = a && a['stroke-linecap'] || 'butt',
      r = e._addDefAttribs() ? serializeArgs(t, 'path', E, 'fill', NONE, 'stroke', BLACK, 'stroke-linecap', i) : serializeArgs(t),
      o = R._engine.path(e, r, n);

  return e.__set__ && e.__set__.push(o), e._elementsById[o.id] = o;
}, paperproto.image = function () {
  var e = this,
      t = getArrayCopy(arguments),
      n = lastArgIfGroup(t, !0),
      a = e._addDefAttribs() ? serializeArgs(t, 'x', 0, 'y', 0, 'width', 0, 'height', 0) : serializeArgs(t),
      i = R._engine.image(e, a, n);

  return e.__set__ && e.__set__.push(i), e._elementsById[i.id] = i;
}, paperproto.text = function () {
  var e = this,
      t = getArrayCopy(arguments),
      n = lastArgIfGroup(t, !0),
      a = e._addDefAttribs() ? serializeArgs(t, 'x', 0, 'y', 0, 'text', E, 'stroke', NONE, 'fill', BLACK, 'text-anchor', 'middle', 'vertical-align', 'middle') : serializeArgs(t),
      i = R._engine.text(e, a, n, t[1]);

  return e.__set__ && e.__set__.push(i), e._elementsById[i.id] = i;
}, paperproto._addDefAttribs = function () {
  return !(R.svg && this.config && this.config.noDefaultAttribs);
}, paperproto.setConfig = function (e, t) {
  var n = this;
  return void 0 !== e && void 0 !== t && (n.config = n.config || {}, n.config[e] = t), n.config;
}, paperproto._createDOMNodes = function (e, t, n) {
  var a,
      r,
      o,
      s,
      l = this,
      d = {},
      p = R._createNode,
      c = t.tagName,
      g = t.children || [];

  for (s in n || (n = {}), t) {
    'tagName' !== s && 'children' !== s && (d[s] = t[s]);
  }

  if (d.id || (d.id = R.getElementID(R.createUUID())), !l.canvas.getElementById(d.id) && c) for (a = e.appendChild(p(c, d)), n.element = a, n.id = d.id, o = g.length, 0 < o && (n.children = []), r = 0; r < o; r++) {
    n.children[r] = {}, l._createDOMNodes(a, g[r], n.children[r]);
  }
  return n;
}, paperproto.addDefs = function (e) {
  if (R.svg) {
    var t,
        n = this,
        a = {},
        i = n.defs;

    for (t in e) {
      a[t] = {}, n._createDOMNodes(i, e[t], a[t]);
    }

    return a;
  }
}, paperproto.setSize = function (e, t) {
  return R._engine.setSize.call(this, e, t);
}, paperproto.setDimension = function (e, t) {
  var n,
      a = this;
  typeof e == OBJECT ? (n = e.width, t = e.height, a.setSize(e.width, e.height)) : (n = e, a.setSize(n, t));
}, paperproto.attr = function (e) {
  var t = this;
  return null == e ? {
    width: t.width,
    height: t.height
  } : R.is(e, STRING) ? t[e] : (t.setDimension(e), t);
}, paperproto.status = function (e, t) {
  return elproto.status.call(this, e, t);
}, paperproto.animateWith = function (e, t, n, a, i, r, o) {
  return elproto.animateWith.call(this, e, t, n, a, i, r, o);
}, paperproto.animate = function (e, t, n, a) {
  return elproto.animate.call(this, e, t, n, a);
}, paperproto.setViewBox = function (e, t, n, a, i) {
  return R._engine.setViewBox.call(this, e, t, n, a, i);
}, paperproto.getById = function (e) {
  return this._elementsById[e] || null;
}, paperproto.top = paperproto.bottom = null, paperproto.raphael = R;

function x_y() {
  return this.x + S + this.y;
}

function x_y_w_h() {
  return this.x + S + this.y + S + this.width + ' \xD7 ' + this.height;
}

elproto.getBBox = function (e) {
  if (this.removed) return {};
  var t = this._;
  return e ? ((t.dirty || !t.bboxwt) && (this.realPath = getPath[this.type](this), t.bboxwt = pathDimensions(this.realPath), t.bboxwt.toString = x_y_w_h, t.dirty = 0), t.bboxwt) : ((t.dirty || t.dirtyT || !t.bbox) && ((t.dirty || !this.realPath) && (t.bboxwt = 0, this.realPath = getPath[this.type](this)), t.bbox = pathDimensions(mapPath(this.realPath, this.matrix)), t.bbox.toString = x_y_w_h, t.dirty = t.dirtyT = 0), t.bbox);
}, elproto.clone = function (e, t) {
  if (this.removed) return null;
  var n,
      a,
      i = this,
      r = i.attr();
  if (!e) a = i.paper[i.type]().attr(r);else {
    for (n in e) {
      r[n] = e[n];
    }

    a = i.paper[i.type](r, t);
  }
  return i.__set__ && i.__set__.push(a), a;
};

var curveslengths = {},
    getPointAtSegmentLength = function getPointAtSegmentLength(e, t, n, a, i, r, o, s, l) {
  return null == l ? bezlen(e, t, n, a, i, r, o, s) : R.findDotsAtSegment(e, t, n, a, i, r, o, s, getTatLen(e, t, n, a, i, r, o, s, l));
},
    getLengthFactory = function getLengthFactory(e, t) {
  return function (n, a, r) {
    n = path2curve(n);

    for (var o, s, d, c, g, h = E, u = {}, m = 0, f = 0, b = n.length; f < b; f++) {
      if (d = n[f], d[0] === strM) o = +d[1], s = +d[2];else {
        if (c = getPointAtSegmentLength(o, s, d[1], d[2], d[3], d[4], d[5], d[6]), m + c > a) {
          if (t && !u.start) {
            if (g = getPointAtSegmentLength(o, s, d[1], d[2], d[3], d[4], d[5], d[6], a - m), h += ['C' + g.start.x, g.start.y, g.m.x, g.m.y, g.x, g.y], r) return h;
            u.start = h, h = [strM + g.x, g.y + 'C' + g.n.x, g.n.y, g.end.x, g.end.y, d[5], d[6]].join(), m += c, o = +d[5], s = +d[6];
            continue;
          }

          if (!e && !t) return g = getPointAtSegmentLength(o, s, d[1], d[2], d[3], d[4], d[5], d[6], a - m), {
            x: g.x,
            y: g.y,
            alpha: g.alpha
          };
        }

        m += c, o = +d[5], s = +d[6];
      }
      h += d.shift() + d;
    }

    return u.end = h, g = e ? m : t ? u : R.findDotsAtSegment(o, s, d[0], d[1], d[2], d[3], d[4], d[5], 1), g.alpha && (g = {
      x: g.x,
      y: g.y,
      alpha: g.alpha
    }), g;
  };
},
    getTotalLength = getLengthFactory(1),
    getPointAtLength = getLengthFactory(),
    getSubpathsAtLength = getLengthFactory(0, 1);

R.getTotalLength = getTotalLength, R.getPointAtLength = getPointAtLength, elproto.getTotalLength = function () {
  return 'path' == this.type ? this.node.getTotalLength ? this.node.getTotalLength() : getTotalLength(this.attrs.path) : void 0;
}, elproto.getPointAtLength = function (e) {
  return 'path' == this.type ? getPointAtLength(this.attrs.path, e) : void 0;
};
var ef = R.easing_formulas = {
  linear: function linear(e) {
    return e;
  },
  "<": function _(e) {
    return pow(e, 1.7);
  },
  ">": function _(e) {
    return pow(e, .48);
  },
  "<>": function _(e) {
    var n = .48 - e / 1.04,
        a = mathSqrt(.1734 + n * n),
        i = a - n,
        r = pow(abs(i), 1 / 3) * (0 > i ? -1 : 1),
        o = -a - n,
        s = pow(abs(o), 1 / 3) * (0 > o ? -1 : 1),
        l = r + s + .5;
    return 3 * (1 - l) * l * l + l * l * l;
  },
  backIn: function backIn(e) {
    var t = 1.70158;
    return e * e * ((t + 1) * e - t);
  },
  backOut: function backOut(e) {
    --e;
    var t = 1.70158;
    return e * e * ((t + 1) * e + t) + 1;
  },
  elastic: function elastic(e) {
    return e === !!e ? e : pow(2, -10 * e) * mathSin((e - .075) * (2 * PI) / .3) + 1;
  },
  bounce: function bounce(e) {
    var t,
        a = 7.5625,
        i = 2.75;
    return e < 1 / i ? t = a * e * e : e < 2 / i ? (e -= 1.5 / i, t = a * e * e + .75) : e < 2.5 / i ? (e -= 2.25 / i, t = a * e * e + .9375) : (e -= 2.625 / i, t = a * e * e + .984375), t;
  },
  oneBounceOut: function oneBounceOut(e) {
    return .9 >= e ? 1.33 * ef.easeIn(e) : 1.2 - e / 5;
  },
  elasticOnce: function elasticOnce(e) {
    var t = .9;
    return e === !!e ? e : Math.pow(2, -10 * e) * Math.sin((e - t / 4) * (2 * Math.PI) / t) + 1;
  },
  easeInQuad: function easeInQuad(e) {
    return e * e;
  },
  easeOutQuad: function easeOutQuad(e) {
    return e * (2 - e);
  },
  easeInOutQuad: function easeInOutQuad(e) {
    return .5 > e ? 2 * e * e : -1 + (4 - 2 * e) * e;
  },
  easeInCubic: function easeInCubic(e) {
    return e * e * e;
  },
  easeOutCubic: function easeOutCubic(e) {
    return --e * e * e + 1;
  },
  easeInOutCubic: function easeInOutCubic(e) {
    return .5 > e ? 4 * e * e * e : (e - 1) * (2 * e - 2) * (2 * e - 2) + 1;
  },
  easeInQuart: function easeInQuart(e) {
    return e * e * e * e;
  },
  easeOutQuart: function easeOutQuart(e) {
    return 1 - --e * e * e * e;
  },
  easeInOutQuart: function easeInOutQuart(e) {
    return .5 > e ? 8 * e * e * e * e : 1 - 8 * --e * e * e * e;
  },
  easeInQuint: function easeInQuint(e) {
    return e * e * e * e * e;
  },
  easeOutQuint: function easeOutQuint(e) {
    return 1 + --e * e * e * e * e;
  },
  easeInOutQuint: function easeInOutQuint(e) {
    return .5 > e ? 16 * e * e * e * e * e : 1 + 16 * --e * e * e * e * e;
  }
};
ef.easeIn = ef['ease-in'] = ef['<'], ef.easeOut = ef['ease-out'] = ef['>'], ef.easeInOut = ef['ease-in-out'] = ef['<>'], ef['back-in'] = ef.backIn, ef['back-out'] = ef.backOut;

var requestAnimFrame,
    animationElements = [],
    animation = function animation() {
  for (var n, a, r, o, s = +new Date(), d = 0, p = [], c = 0, g = 0; d < animationElements.length; d++) {
    if (o = animationElements[d], !(o.el.removed || o.paused || o.parentEl && o.parentEl.e && o.parentEl.e.paused)) {
      for (var h, u, m, f = s - o.start, y = o.ms, x = o.easing, b = o.from, v = o.diff, _ = o.to, A = o.t, t = o.el, k = {}, C = {}, T = !R.stopPartialEventPropagation, c = 0, w = o.el && o.el.animElements && o.el.animElements.peek(); w && w.pos <= f / y;) {
        p.push(o.el.animElements.deq()), w = o.el.animElements.peek();
      }

      if (o.initstatus ? (f = (o.initstatus * o.anim.top - o.prev) / (o.percent - o.prev) * y, o.status = o.initstatus, delete o.initstatus, o.stop && (delete o.el, animationElements.splice(d--, 1))) : o.status = (o.prev + (o.percent - o.prev) * (f / y)) / o.anim.top, u = y, o.parentEl && o.parentEl.animElements ? (y = o.delayend - o.delaystart, f = o.parentEl.cPos - o.delaystart) : o.el.animElements && (o.el.cPos = f / y), !(0 > f)) if (f < y) {
        var P = x(f / y);

        for (var I in y = u, b) {
          if (b[HAS](I)) {
            switch (availableAnimAttrs[I]) {
              case 'number':
                h = +b[I] + P * y * v[I];
                break;

              case 'colour':
                if (!v[I].length) n = b[I].opacity + P * y * v[I].opacity, isNaN(n) && (n = 1), h = 'rgba(' + [upto255(round(b[I].r + P * y * v[I].r)), upto255(round(b[I].g + P * y * v[I].g)), upto255(round(b[I].b + P * y * v[I].b)), n].join(COMMA) + ')';else {
                  for (h = [], c = 0, L = b[I].length; c < L; ++c) {
                    0 === c ? b[I].isRadial || v[I].isRadial ? (a = 'xr(', a += b[I][0].f1 * (1 - P) + v[I][0].f1 * P || E, a += ',', a += b[I][0].f2 * (1 - P) + v[I][0].f2 * P || E, a += ',', a += 100 * (b[I][0].f3 * (1 - P) + v[I][0].f3 * P) || E, a += '%,', a += b[I][0].f4 * (1 - P) + v[I][0].f4 * P || E, a += ',', a += b[I][0].f5 * (1 - P) + v[I][0].f5 * P, a += ',', a += b[I][0].f6, a += ')', h.push(a)) : (h.push(b[I][c] * (1 - P) + P * v[I][c]), 0 >= h[0] && (h[0] += 360)) : h.push('rgba(' + [upto255(round(b[I][c].r + P * y * v[I][c].r)), upto255(round(b[I][c].g + P * y * v[I][c].g)), upto255(round(b[I][c].b + P * y * v[I][c].b)), b[I][c].opacity + P * y * v[I][c].opacity].join(COMMA) + '):' + b[I][c].position);
                  }

                  h = h.join('-'), (b[I].isRadial || v[I].isRadial) && (h = h.replace('-', E));
                }
                break;

              case 'path':
                h = [];

                for (var c = 0, L = b[I].length; c < L; c++) {
                  h[c] = [b[I][c][0]];
                  var F = b[I][c] ? b[I][c].length : 0;

                  for (var O = 1; O < F; O++) {
                    h[c][O] = (+b[I][c][O] + P * y * v[I][c][O]).toFixed(4);
                  }

                  h[c] = h[c].join(S);
                }

                h = h.join(S);
                break;

              case 'transform':
                if (v[I].real) for (h = [], c = 0, L = b[I].length; c < L; c++) {
                  for (h[c] = [b[I][c][0]], O = 1, F = b[I][c].length; O < F; O++) {
                    h[c][O] = b[I][c][O] + P * y * v[I][c][O];
                  }
                } else {
                  var N = function N(e) {
                    return +b[I][e] + P * y * v[I][e];
                  };

                  h = [[mStr, N(0), N(1), N(2), N(3), N(4), N(5)]];
                }
                break;

              case 'csv':
                if ('clip-rect' === I) for (h = [], c = 4; c--;) {
                  h[c] = +b[I][c] + P * y * v[I][c];
                }
                break;

              case 'text-bound':
                h = [][CONCAT](b[I]);
                break;

              default:
                var B = [][CONCAT](b[I]);

                for (h = [], c = t.ca[I].length; c--;) {
                  h[c] = +B[c] + P * y * v[I][c];
                }

            }

            k[I] = h;
          }
        }

        t.attr(k), T && function (e, t, n) {
          setTimeout(function () {
            eve('raphael.anim.frame.' + e, t, n);
          });
        }(t.id, t, o.anim);
      } else {
        if (function (e, t, n) {
          setTimeout(function () {
            T && eve('raphael.anim.frame.' + t.id, t, n), T && eve('raphael.anim.finish.' + t.id, t, n), R.is(e, FUNCTION) && e.call(t);
          });
        }(o.callback, t, o.anim), t.attr(_), delete o.el, animationElements.splice(d--, 1), 1 < o.repeat && !o.next) {
          for (m in _) {
            _[HAS](m) && (C[m] = o.totalOrigin[m]);
          }

          o.el.attr(C), runAnimation(o.anim, o.el, o.anim.percents[0], null, o.totalOrigin, o.repeat - 1);
        }

        o.next && !o.stop && runAnimation(o.anim, o.el, o.next, null, o.totalOrigin, o.repeat);
      }
    }
  }

  for (R.svg && t && t.paper && t.paper.safari(), d = 0, g = p.length; d < g; ++d) {
    r = R.getInstantAnimFrameFn(), r(function (e) {
      return function () {
        runAnimation.apply(null, p[e].params);
      };
    }(d));
  }

  animationElements.length && (requestAnimFrame || R.getAnimFrameFn())(animation);
},
    upto255 = function upto255(e) {
  return 255 < e ? 255 : 0 > e ? 0 : e;
},
    checkPercentage = function checkPercentage(e) {
  return 1 < e && (e = 1), 0 > e && (e = 0), e;
};

R.getAnimFrameFn = function () {
  return requestAnimFrame = R.requestAnimFrame || _win.webkitRequestAnimationFrame || _win.mozRequestAnimationFrame || _win.oRequestAnimationFrame || _win.msRequestAnimationFrame || function (e) {
    setTimeout(e, 16);
  };
}, R.getInstantAnimFrameFn = function () {
  return R.instantRequestAnimFrame || _win.webkitRequestAnimationFrame || _win.mozRequestAnimationFrame || _win.oRequestAnimationFrame || _win.msRequestAnimationFrame || function (e) {
    setTimeout(e, 16);
  };
}, elproto.animateWith = function (e, t, n, r, o, s, l) {
  var d,
      p = this,
      c = {};

  for (d in l = l || {}, l) {
    l.hasOwnProperty(d) && (c[d] = l[d]);
  }

  if (l = c, p.removed) return s && s.call(p), p;
  if (0 === r) return R.is(s, FUNCTION) && setTimeout(function () {
    s.call(p);
  }, 0), p.attr(n);
  var g = n instanceof Animation ? n : R.animation(n, r, o, s);
  l.start = checkPercentage(l.start || 0), l.end = checkPercentage(l.end || 1), l.start >= l.end && (l.start = l.end), !l.from && .01 < l.start ? (e.animElements = e.animElements || new PriorityQueue(function (e, t) {
    return t.pos - e.pos;
  }), e.animElements.enq({
    pos: l.start,
    attr: l.start === l.end,
    params: [g, p, g.percents[0], null, p.attr(), void 0, e, {
      start: l.start,
      end: l.end,
      smartMorph: l.smartMorph,
      hookFn: l.hookFn
    }, n],
    executeOb: {
      el: this,
      attrs: n,
      callback: s,
      hookFn: l.hookFn
    }
  })) : runAnimation(g, p, g.percents[0], null, p.attr(), void 0, e, l);

  for (var a = 0, h = animationElements.length; a < h; a++) {
    if (animationElements[a].anim === t && animationElements[a].el === e) {
      animationElements[h - 1].start = animationElements[a].start;
      break;
    }
  }

  return p;
};

function CubicBezierAtTime(e, t, n, a, i, r) {
  function o(e) {
    return ((p * e + d) * e + l) * e;
  }

  function s(e, t) {
    var n, a, r, s, c, g;

    for (r = e, g = 0; 8 > g; g++) {
      if (s = o(r) - e, abs(s) < t) return r;
      if (c = (3 * p * r + 2 * d) * r + l, 1e-6 > abs(c)) break;
      r -= s / c;
    }

    if (n = 0, a = 1, r = e, r < n) return n;
    if (r > a) return a;

    for (; n < a;) {
      if (s = o(r), abs(s - e) < t) return r;
      e > s ? n = r : a = r, r = (a - n) / 2 + n;
    }

    return r;
  }

  var l = 3 * t,
      d = 3 * (a - t) - l,
      p = 1 - l - d,
      c = 3 * n,
      g = 3 * (i - n) - c;
  return function (e, n) {
    var a = s(e, n);
    return (((1 - c - g) * a + g) * a + c) * a;
  }(e, 1 / (200 * r));
}

elproto.onAnimation = function (e) {
  return e ? eve.on('raphael.anim.frame.' + this.id, e) : eve.unbind('raphael.anim.frame.' + this.id), this;
};

function Animation(e, t) {
  var n = [],
      a = {};

  if (this.ms = t, this.times = 1, e) {
    for (var i in e) {
      e[HAS](i) && (a[toFloat(i)] = e[i], n.push(toFloat(i)));
    }

    n.sort(sortByNumber);
  }

  this.anim = a, this.top = n[n.length - 1], this.percents = n;
}

Animation.prototype.delay = function (e) {
  var t = new Animation(this.anim, this.ms);
  return t.times = this.times, t.del = +e || 0, t;
}, Animation.prototype.repeat = function (e) {
  var t = new Animation(this.anim, this.ms);
  return t.del = this.del, t.times = math.floor(mmax(e, 0)) || 1, t;
};

var converToRadialIfOneRadial = function converToRadialIfOneRadial(e, t, n) {
  var a = 0;
  e.isRadial && !t.isRadial && (a += +t[0], t[0] = {
    f1: 0,
    f2: 0,
    f3: 0,
    f4: 0,
    f5: 0,
    f6: E
  }, t.isRadial = !0), n || converToRadialIfOneRadial(t, e, !0);
};

function colorNormalizer(e, t, n) {
  'use strict';

  function a(e) {
    var t,
        a = 0,
        r = 0,
        o = 0,
        s = [],
        l = {},
        d = 0,
        p = 0,
        c = 0,
        g = 0,
        h = 0,
        u = 0,
        m = {
      f1: .5,
      f2: .5
    };

    for (1 === e.length && (e[0] === NONE && (e[0] = 'rgba(0,0,0,0)'), e.unshift(0), e.defaultAngleSet = !0), isNaN(e[0]) ? ~'rx'.indexOf(e[0].charAt(0)) ? (e.isRadial = !0, g = 1, -1 !== e[0].indexOf(')') && (g = e[0].indexOf(')'), h = e[0].indexOf('(') + 1, u = g, s = e[0].substr(h, u - h).split(','), m.f1 = parseFloat(s[0]) || 0, m.f2 = parseFloat(s[1]) || 0, ~s[2].indexOf('%') && (s[2] = parseFloat(s[2]) / 100), m.f3 = parseFloat(s[2]) || 0, m.f4 = parseFloat(s[3]) || 0, m.f5 = parseFloat(s[4]) || 0, m.f6 = s[5]), e[0] = e[0].substr(u + 1), e.unshift(m)) : e[0] = 0 : e[0] = +e[0], (a = 1, r = e.length); a < r; ++a) {
      s = e[a].split(':'), l = n(s[0]), e[a] = {}, e[a].r = l.r, e[a].g = l.g, e[a].b = l.b, e[a].opacity = l.opacity, e[a].opacity = +e[a].opacity, isNaN(e[a].opacity) && (e[a].opacity = 1), e[a].position = +s[1];
    }

    if (e.sort(function (e, t) {
      return 'number' == typeof e || e.f1 ? -1 : 'number' == typeof t || e.f2 ? 1 : isNaN(e.position) && isNaN(t.position) ? 0 : isNaN(e.position) ? -1 : isNaN(t.position) ? 1 : e.position - t.position;
    }), 0 != +e[1].position) if (isNaN(e[1].position)) e[1].position = 0;else {
      for (t in l = {}, e[1]) {
        l[t] = e[1][t];
      }

      for (l.position = 0, e.push({}), a = e.length - 1; 1 != a; --a) {
        e[a] = e[a - 1];
      }

      e[1] = l;
    }
    if (r = e.length - 1, 100 !== e[r].position) if (isNaN(e[r].position)) e[r].position = 100;else {
      for (t in l = {}, e[r]) {
        l[t] = e[r][t];
      }

      l.position = 100, e.push(l);
    }

    for (a = 2, r = e.length; a < r; ++a) {
      if (!e[a].position) {
        for (d = e[a - 1].position, c = 1, o = a + 1; o < r; ++o) {
          if (++c, !isNaN(e[o].position)) {
            p = +e[o].position;
            break;
          }
        }

        e[a].position = d + (p - d) / c;
      }
    }

    return e.getColorAtPosition = function (e) {
      for (var t = -1, n = this.length, a = 1, r = this.length, o = 0, s = E, l = {
        r: 0,
        g: 0,
        b: 0
      }; a < r - 1; ++a) {
        if (this[a].position <= e && (t = a, n = a + 1), !(this[a].position < e) && this[a].position >= e) {
          n = a;
          break;
        }
      }

      for (s in o = (e - this[t].position) / (this[n].position - this[t].position), isNaN(o) && (o = 0), l) {
        l[s] = upto255((1 - o) * this[t][s] + o * this[n][s]);
      }

      return l.position = e, l.opacity = (1 - o) * this[t].opacity + o * this[n].opacity, l;
    }, e;
  }

  var r,
      o,
      s = 0,
      l = 0,
      d = [],
      p = [],
      c = {},
      g = 0,
      h = [];
  if (e = e.constructor === Array ? e[0] : e, t = t.constructor === Array ? t[0] : t, r = e.split('-'), o = t.split('-'), 1 === r.length && 1 === o.length) return [e, t];

  for (r = a(r), o = a(o), !r.defaultAngleSet && o.defaultAngleSet && (o[0] = r[0]), !o.defaultAngleSet && r.defaultAngleSet && (r[0] = o[0]), converToRadialIfOneRadial(r, o), (s = 1, l = r.length); s < l; ++s) {
    g = r[s].position, h.push(g);
  }

  for (s = 1, l = o.length; s < l; ++s) {
    g = o[s].position, -1 === h.indexOf(g) && h.push(g);
  }

  for (h.push(0), h.sort(function (e, t) {
    return e - t;
  }), d = [r[0]], (s = 1, l = h.length); s < l; ++s) {
    g = h[s], c = r.getColorAtPosition(g), d.push(c);
  }

  for (p = [o[0]], s = 1, l = h.length; s < l; ++s) {
    g = h[s], c = o.getColorAtPosition(g), p.push(c);
  }

  return d.isRadial = r.isRadial, p.isRadial = o.isRadial, [d, p];
}

function pathNormalizer(e, t) {
  'use strict';

  function n(e) {
    var t = [],
        n = 0,
        a = e.length;
    if (typeof e == STRING) return e;

    for (n = 0; n < a; ++n) {
      if (!e[n].join) return;
      n && e[n + 1] && 'M' === e[n + 1][0] && 'M' === e[n][0] || t.push(e[n].join(S));
    }

    for (t = t.join(E), t = t.split(/[Mm]/).slice(1), (n = 0, a = t.length); n < a; ++n) {
      t[n] = 'M' + t[n];
    }

    return t;
  }

  function a(e) {
    var t = 0,
        n = 0,
        a = [];

    for (e = e || [], n = e.length, t = 0; t < n; ++t) {
      e[t].length - 1 && a.push(e[t].join(S));
    }

    return a.join(E);
  }

  function r(e, t) {
    for (var n = e.length; n-- - 1 && e[n].slice(1).toString() === e[n - 1].slice(1).toString();) {
      e.pop();
    }

    1 === e.length && t && (e.length = 0);
  }

  function o(e, t) {
    for (var n = [], a = [], r = e.length, o = 0, s = 0, l = 0, d = 0, c = 0, g = t - r; 0 <= g;) {
      o = e.length - 1, e.push(e.slice(o)[0]), --g;
    }

    for (r = e.length, o = 0; o <= t; ++o) {
      a.push(p(o / t * r));
    }

    for (o = 0, s = a.length - 1; o < s; ++o) {
      n.push(e.slice(a[o], a[o + 1])), 'M' !== n[o][0][0] && n[o][0][0] !== mStr && (d = n[o - 1].length - 1, l = n[o - 1][d][1], c = n[o - 1][d][2], n[o].unshift(['M', l, c]));
    }

    return n;
  }

  function s(e) {
    var t = [],
        n = [],
        a = [],
        r = 0,
        s = 0,
        l = !0;

    if (0 !== e) {
      for (0 < e ? (t = u, l = !1) : (e = -e, t = h), r = 0, s = t.length; r < s; ++r) {
        n.push(1);
      }

      for (; e--;) {
        --r, 0 > r && (r = s - 1), n[r]++;
      }

      for (r = 0; r < s; ++r) {
        1 === n[r] ? a.push(t[r]) : a.push.apply(a, o(t[r], n[r]));
      }

      l ? h = a : u = a;
    }
  }

  var l,
      d = Math.max,
      p = Math.round,
      c = [],
      g = [],
      h = n(e),
      u = n(t),
      m = 0,
      f = 0,
      y = document.createElementNS && document.createElementNS.bind(document),
      x = y && y('http://www.w3.org/2000/svg', 'path');
  if (!h || !u || !x) return [e, t];
  if (function (e, t) {
    function n(e) {
      for (var t = e.length; t-- - 1 && e[t].join(E) === e[t - 1].join(E);) {
        e.pop();
      }
    }

    function a(e) {
      for (var t = E, n = 0, a = e.length; n < a; ++n) {
        t += e[n].join(S);
      }

      return t;
    }

    var i,
        r,
        o = E,
        s = E;
    return (x.setAttribute('d', 'M300 10 L300 300 C50 310,50 640,350 650C600 640,600 310,400 300 L400 10 L295 10'), i = x.getTotalLength(), r = x.getPointAtLength(10), !!(1829.1 > i || 1829.2 < i)) || 300 !== p(r.x) || 20 !== p(r.y) || (n(e), n(t), o = a(e), s = a(t), !(2 < o.split(/[Mm]/).length || 2 < s.split(/[Mm]/).length) && e.length === t.length);
  }(e, t)) return [e, t];
  if (!e || !t) return [e, t];
  if (!document.createElementNS) return [e, t];
  if (h = n(e), u = n(t), -1 !== h.join().indexOf('undefined')) return [e, t];
  if (-1 !== u.join().indexOf('undefined')) return [e, t];
  if (!x.getTotalLength || !x.getPointAtLength) return [e, t];

  for (f = d(h.length, u.length), m = 0; m < f; ++m) {
    l = _pathNormalizer(h[m], u[m]), h[m] = l[0], u[m] = l[1];
  }

  for (m = h.length; m--;) {
    r(h[m], m), h[m].length || h.pop();
  }

  for (m = u.length; m--;) {
    r(u[m], m), u[m].length || u.pop();
  }

  for (s(h.length - u.length), f = d(h.length, u.length), m = 0; m < f; ++m) {
    l = _pathNormalizer(a(h[m]), a(u[m])), h[m] = l[0], u[m] = l[1];
  }

  for (m = 0, f = h.length; m < f; ++m) {
    c = c.concat(h[m]);
  }

  for (m = 0, f = u.length; m < f; ++m) {
    g = g.concat(u[m]);
  }

  return [c, g];
}

function commonPathCalculator(e, t) {
  'use strict';

  function n(e) {
    var t = 0,
        n = 0;

    for (e = e.split(/[MCLmcl]/).slice(1), t = 0, n = e.length; t < n; ++t) {
      e[t] = e[t].split(S).slice(1), t || e[t].unshift('M'), t && (2 === e[t].length && e[t].unshift(strL) || e[t].unshift('C'));
    }

    return e;
  }

  function a(e, t) {
    var n,
        a,
        r = 0,
        o = e.length;

    for (r = 0, o = e.length; r < o; ++r) {
      n = e[r].join(S), a = e[r], 'C' === a[0] && a[3] === a[5] && a[4] === a[6] ? e[r].stringValue = [strL, a[3], a[4]].join(S) : a.stringValue = n, t[a.stringValue] && t[a.stringValue].push(r), t[a.stringValue] || (t[a.stringValue] = [r]);
    }
  }

  function r(e, t, n, a, r) {
    for (var o, s = n, l = 0, d = 0; s < a; ++s) {
      if (o = t[e[s].stringValue], o) for (l = 0, d = o.length; l < d; ++l) {
        if (o[l] >= r) return {
          index: s,
          mapValue: o[l],
          diff: s - n
        };
      }
    }

    return -1;
  }

  function o(e) {
    var t = e.length - 1;
    return ['M', e[t - 1], e[t]].join(S);
  }

  function s(e) {
    return e.join(E);
  }

  var l,
      d,
      p = 0,
      c = 0,
      g = 0,
      h = 0,
      u = 0,
      m = 0,
      f = {},
      y = {},
      x = [],
      b = [],
      v = -1,
      _ = -1,
      A = !0;

  for (e = n(e), t = n(t), a(e, f), a(t, y), g = e.length, h = t.length, p = 0, c = 0; p < g && c < h;) {
    if (++v, ++_, x[v] = [], b[_] = [], A = e[p].stringValue === t[c].stringValue, p && (x[v].push(o(e[p - 1])), b[_].push(o(t[c - 1]))), A) for (; p < g && c < h && e[p].stringValue === t[c].stringValue;) {
      x[v].push(e[p].stringValue), b[_].push(t[c].stringValue), ++p, ++c;
    } else {
      for (l = r(e, y, p, g, c), d = r(t, f, c, h, p), u = l.index, m = l.mapValue, (!~l || l.diff > d.diff) && (u = d.mapValue, m = d.index), ~l || ~d || (u = g - 1, m = h - 1); p <= u;) {
        x[v].push(e[p].stringValue), ++p;
      }

      for (; c <= m;) {
        b[_].push(t[c].stringValue), ++c;
      }
    }
    x[v] = s(x[v]), b[_] = s(b[_]);
  }

  if (p < g) {
    for (++v, x[v] = [], x[v].push(o(e[p - 1])), ++_, b[_] = [], b[_].push(o(t[c - 1])); p < g;) {
      x[v].push(e[p].stringValue), ++p;
    }

    x[v] = s(x[v]);
  }

  if (c < h) {
    for (++v, x[v] = [], x[v].push(o(e[p - 1])), ++_, b[_] = [], b[_].push(o(t[c - 1])); c < h;) {
      b[_].push(t[c].stringValue), ++c;
    }

    b[_] = s(b[_]);
  }

  return [x, b];
}

function _pathNormalizer(e, t) {
  'use strict';

  function n(e, t) {
    var n,
        a,
        r = 0,
        o = {},
        s = 0,
        l = 0,
        d = [],
        p = [],
        c = 0,
        g = Math.round;

    for (n = document.createElementNS('http://www.w3.org/2000/svg', 'path'), n.setAttribute('d', e), a = document.createElementNS('http://www.w3.org/2000/svg', 'path'), a.setAttribute('d', t), s = n.getTotalLength(), l = a.getTotalLength(), c = .15 * Math.max(s, l), c = Math.ceil(c), c && isFinite(c) && !(10 > c) || (c = 10), r = 0; r <= c; ++r) {
      o = n.getPointAtLength(r / c * s), d.push([r ? strL : strM, g(o.x), g(o.y)]), o = a.getPointAtLength(r / c * l), p.push([r ? strL : strM, g(o.x), g(o.y)]);
    }

    return [d, p];
  }

  var a,
      r,
      o = 0,
      s = 0,
      l = [],
      d = [];

  for (e && 'M  ' !== e || (e = t.split(S).slice(0, 3).join(S).replace(/[LC]/, E)), t && 'M  ' !== t || (t = e.split(S).slice(0, 3).join(S).replace(/[LC]/, E)), a = commonPathCalculator(e, t), (o = 0, s = a[0].length); o < s; ++o) {
    r = n(a[0][o], a[1][o]), o ? (l = l.concat(r[0].slice(1)), d = d.concat(r[1].slice(1))) : (l = l.concat(r[0]), d = d.concat(r[1]));
  }

  return [l, d];
}

function runAnimation(t, n, a, r, o, s, l, d) {
  a = toFloat(a);
  var p,
      c,
      g,
      h,
      u,
      f,
      y,
      x,
      b = t.ms,
      v = {},
      A = {},
      k = {};

  if (null !== n.type) {
    if (d = d || {}, d.hookFn && d.hookFn.call(n), d.from = d.from || {}, r) for (T = 0, w = animationElements.length; T < w; T++) {
      var C = animationElements[T];

      if (C.el.id === n.id && C.anim === t) {
        C.percent == a ? c = C : (delete C.el.e, delete C.el, animationElements.splice(T, 1), g = 1), n.attr(C.totalOrigin);
        break;
      }
    } else r = +A;

    for (var T = 0, w = t.percents.length; T < w; T++) {
      if (t.percents[T] === a || t.percents[T] > r * t.top) {
        a = t.percents[T], u = t.percents[T - 1] || 0, b = b / t.top * (a - u), h = t.percents[T + 1], p = t.anim[a];
        break;
      } else r && n.attr(t.anim[t.percents[T]]);
    }

    if (p) {
      if (!c) {
        for (var S in p) {
          if (p[HAS](S)) if (availableAnimAttrs[HAS](S) || n.ca[S]) {
            switch (v[S] = d.from[S] || n.attr(S), null == v[S] && (v[S] = availableAttrs[S]), A[S] = p[S], x = !1, availableAnimAttrs[S]) {
              case 'number':
                y = A[S] - v[S], (y || isNaN(y)) && (x = !0), k[S] = y / b;
                break;

              case 'colour':
                if (v[S] === A[S]) break;else x = !0;
                var E = colorNormalizer(v[S], A[S], R.getRGB);
                v[S] = E[0];
                var P = E[1];
                if (typeof P == STRING) v[S].toLowerCase() === NONE ? v[S] = {
                  r: 0,
                  g: 0,
                  b: 0,
                  opacity: 0
                } : (v[S] = R.getRGB(v[S]), !v[S].opacity && (v[S].opacity = 1)), A[S].toLowerCase() === NONE ? P = {
                  r: 0,
                  g: 0,
                  b: 0,
                  opacity: 0
                } : (P = R.getRGB(A[S]), !P.opacity && (P.opacity = 1)), k[S] = {
                  r: (P.r - v[S].r) / b,
                  g: (P.g - v[S].g) / b,
                  b: (P.b - v[S].b) / b,
                  opacity: (P.opacity - v[S].opacity) / b
                };else for (k[S] = [], T = 0, w = v[S].length; T < w; ++T) {
                  0 === T ? k[S].push(P[0]) : k[S].push({
                    r: (P[T].r - v[S][T].r) / b,
                    g: (P[T].g - v[S][T].g) / b,
                    b: (P[T].b - v[S][T].b) / b,
                    opacity: (P[T].opacity - v[S][T].opacity) / b
                  });
                }
                break;

              case 'path':
                var I,
                    L = path2curve(v[S], A[S]);

                for (d.smartMorph && (L = pathNormalizer(L[0], L[1], d)), I = L[1], v[S] = L[0], k[S] = [], (T = 0, w = v[S].length); T < w; T++) {
                  k[S][T] = [0];
                  var F = v[S][T] ? v[S][T].length : 0;

                  for (var O = 1; O < F; O++) {
                    k[S][T][O] = (I[T][O] - v[S][T][O]) / b, !x && k[S][T][O] && (x = !0);
                  }
                }

                break;

              case 'transform':
                var N = n._,
                    _ = equaliseTransform(N[S], A[S]);

                if (x = !0, _) for (v[S] = _.from, A[S] = _.to, k[S] = [], k[S].real = !0, (T = 0, w = v[S].length); T < w; T++) {
                  for (k[S][T] = [v[S][T][0]], O = 1, F = v[S][T].length; O < F; O++) {
                    k[S][T][O] = (A[S][T][O] - v[S][T][O]) / b;
                  }
                } else {
                  var B = n.matrix || new Matrix(),
                      m = {
                    _: {
                      transform: N.transform
                    },
                    getBBox: function getBBox() {
                      return n.getBBox(1);
                    }
                  };
                  v[S] = [B.a, B.b, B.c, B.d, B.e, B.f], extractTransform(m, A[S]), A[S] = m._.transform, k[S] = [(m.matrix.a - B.a) / b, (m.matrix.b - B.b) / b, (m.matrix.c - B.c) / b, (m.matrix.d - B.d) / b, (m.matrix.e - B.e) / b, (m.matrix.f - B.f) / b];
                }
                break;

              case 'csv':
                var D = Str(p[S])[SPLIT](separator),
                    M = Str(v[S])[SPLIT](separator);
                if ('clip-rect' === S) for (v[S] = M, k[S] = [], T = M.length; T--;) {
                  y = D[T] - v[S][T], (y || isNaN(y)) && (x = !0), k[S][T] = y / b;
                }
                A[S] = D;
                break;

              default:
                for (D = [][CONCAT](p[S]), M = [][CONCAT](v[S]), k[S] = [], T = n.ca[S].length; T--;) {
                  y = (D[T] || 0) - (M[T] || 0), (y || isNaN(y)) && (x = !0), k[S][T] = y / b;
                }

            }

            x || (delete v[S], delete A[S], delete p[S], delete k[S]);
          } else (R._availableAttrs[HAS](S) || 'text' === S || n.ca[S]) && (n.attr(S, p[S]), delete p[S]);
        }

        var V = p.easing,
            Y = R.easing_formulas[V];
        if (!Y) if (Y = Str(V).match(bezierrg), Y && 5 === Y.length) {
          var q = Y;

          Y = function Y(e) {
            return CubicBezierAtTime(e, +q[1], +q[2], +q[3], +q[4], b);
          };
        } else Y = pipe;
        if (f = p.start || t.start || +new Date(), n.e = C = {
          anim: t,
          percent: a,
          timestamp: f,
          start: f + (t.del || 0),
          status: 0,
          initstatus: r || 0,
          stop: !1,
          ms: b,
          easing: Y,
          from: v,
          diff: k,
          to: A,
          el: n,
          callback: p.callback,
          prev: u,
          next: h,
          repeat: s || t.times,
          origin: n.attr(),
          totalOrigin: o,
          parentEl: l,
          delayend: d && d.end,
          delaystart: d && d.start
        }, animationElements.push(C), r && !c && !g && (C.stop = !0, C.start = new Date() - b * r, 1 === animationElements.length)) return animation();
        g && (C.start = new Date() - C.ms * r), 1 === animationElements.length && (requestAnimFrame || R.getAnimFrameFn())(animation);
      } else c.initstatus = r, c.start = new Date() - c.ms * r;

      eve('raphael.anim.start.' + n.id, n, t);
    }
  }
}

R.animation = function (e, t, n, a, i) {
  if (e instanceof Animation) return e;
  (R.is(n, FUNCTION) || !n) && (a = a || n || null, n = null), R.stopPartialEventPropagation || (R.stopPartialEventPropagation = i), e = Object(e), t = +t || 0;
  var r,
      o,
      s = {};

  for (o in e) {
    e[HAS](o) && toFloat(o) != o && toFloat(o) + '%' != o && (r = !0, s[o] = e[o]);
  }

  return a && (r = !0), r ? (n && (s.easing = n), a && (s.callback = a), new Animation({
    100: s
  }, t)) : new Animation(e, t);
}, elproto.animate = function (e, t, n, a) {
  var i = this;
  if (i.removed) return a && a.call(i), i;
  var r = e instanceof Animation ? e : R.animation(e, t, n, a);
  return runAnimation(r, i, r.percents[0], null, i.attr()), i;
}, elproto.status = function (t, n) {
  var a,
      r,
      o = [],
      s = 0;
  if (null != n) return runAnimation(t, this, -1, mmin(n, 1)), this;

  for (a = animationElements.length; s < a; s++) {
    if (r = animationElements[s], r.el.id === this.id && (!t || r.anim === t)) {
      if (t) return r.status;
      o.push({
        anim: r.anim,
        status: r.status
      });
    }
  }

  return t ? 0 : o;
}, elproto.pause = function (t, n) {
  var a,
      r,
      o = +new Date();

  for (r = 0; r < animationElements.length; r++) {
    a = animationElements[r], (a.el.id === this.id || n && a.parentEl && a.parentEl.e.el && a.parentEl.e.el.id === this.id) && (!t || a.anim === t) && !1 !== eve('raphael.anim.pause.' + this.id, this, a.anim) && (a.paused = !0, a.pauseStart = o);
  }

  return this;
}, elproto.resume = function (t, n) {
  var a,
      r,
      o = +new Date();

  for (r = 0; r < animationElements.length; r++) {
    a = animationElements[r], (a.el.id === this.id || n && a.parentEl && a.parentEl.e.el && a.parentEl.e.el.id === this.id) && (!t || a.anim === t) && !1 !== eve('raphael.anim.resume.' + this.id, this, a.anim) && (delete a.paused, a.el.status(a.anim, a.status), a.pauseEnd = o, a.start += (a.parentEl && a.parentEl.e.pauseEnd || a.pauseEnd) - (a.parentEl && a.parentEl.e.pauseStart || a.pauseStart) || 0);
  }

  return this;
}, elproto.stop = function (t, n, a) {
  var r, o, s;
  if (n) for (o = animationElements.length - 1; 0 <= o; o--) {
    r = animationElements[o], (r.el.id === this.id || r.parentEl && r.parentEl.id === this.id) && (!t || animationElements[o].anim === t) && (s = r.el, a && s.attr(r.to), r.callback && r.callback.call(s), delete s.e, delete r.el, animationElements.splice(o, 1));
  } else for (var o = 0; o < animationElements.length; o++) {
    r = animationElements[o], r.el.id !== this.id || t && r.anim !== t || !1 === eve('raphael.anim.stop.' + this.id, this, r.anim) || animationElements.splice(o--, 1);
  }
  return this.animElements && executeAnimQueue(this.animElements), this;
};

function executeAnimQueue(e) {
  for (var t; t = e.deq();) {
    t = t.executeOb, t.hookFn && t.hookFn.call(t.el), t.el.attr(t.attrs), t.callback && t.callback.call(t.el);
  }
}

function stopAnimation(e) {
  for (var t = 0; t < animationElements.length; t++) {
    animationElements[t].el.paper === e && animationElements.splice(t--, 1);
  }
}

eve.on('raphael.remove', stopAnimation), eve.on('raphael.clear', stopAnimation), elproto.toString = function () {
  return "Rapha\xEBl\u2019s object";
}, elproto.toFront = function () {
  if (this.removed) return this;

  var e,
      t,
      n,
      a = this,
      r = R._engine.getNode(a),
      o = a.parent,
      s = a.followers;

  for (R._tofront(a, o) && o.canvas.appendChild(r), t = 0, n = s.length; t < n; t++) {
    (e = s[t]).stalk && e.el[e.stalk](a);
  }

  return a;
}, elproto.toBack = function () {
  if (this.removed) return this;

  var e,
      t,
      n,
      a = this,
      r = R._engine.getNode(a),
      o = a.parent,
      s = a.followers;

  for (R._toback(a, o) && o.canvas.insertBefore(r, o.canvas.firstChild), t = 0, n = s.length; t < n; t++) {
    (e = s[t]).stalk && e.el[e.stalk](a);
  }

  return a;
}, elproto.insertAfter = function (e) {
  if (this.removed) return this;

  var t,
      n,
      a,
      r = this,
      o = R._engine.getNode(r),
      s = R._engine.getLastNode(e),
      l = e.parent.canvas,
      d = r.followers;

  for (s.nextSibling ? l.insertBefore(o, s.nextSibling) : l.appendChild(o), R._insertafter(r, e, r.parent, e.parent), (n = 0, a = d.length); n < a; n++) {
    (t = d[n]).stalk && t.el[t.stalk](e);
  }

  return r;
}, elproto.insertBefore = function (e) {
  if (this.removed) return this;

  var t,
      n,
      a,
      r = this,
      o = R._engine.getNode(r),
      s = R._engine.getNode(e),
      l = r.followers;

  for (e.parent.canvas.insertBefore(o, s), R._insertbefore(r, e, r.parent, e.parent), r.parent = e.parent, (n = 0, a = l.length); n < a; n++) {
    (t = l[n]).stalk && t.el[t.stalk](e);
  }

  return this;
}, elproto.appendChild = function (e) {
  if (this.removed || 'group' !== this.type) return this;
  var t,
      n,
      a,
      r,
      o = this,
      s = o.followers;
  if (e.parent === o) return e.toFront(), o;

  for (n = R._engine.getNode(e), R._tear(e, e.parent), o.canvas.appendChild(n), e.parent = o, o.bottom || (o.bottom = e), e.prev = o.top, e.next = null, o.top && (o.top.next = e), o.top = e, (a = 0, r = s.length); a < r; a++) {
    (t = s[a]).stalk && t.el[t.stalk](e);
  }

  return o;
}, elproto.appendTo = function (e) {
  return e.appendChild(this);
}, elproto.removeChild = function (e) {
  if (this.removed || 'group' !== this.type || e.parent !== this) return this;

  var t = this,
      n = R._engine.getNode(e),
      a = t.paper;

  return R._tear(e, t), a.canvas.appendChild(n), t.parent = a, a.bottom || (a.bottom = t), t.prev = a.top, a.top && (a.top.next = t), a.top = t, t.next = null, t;
}, R.format = function (e, t) {
  var n = getArrayCopy(arguments),
      a = R.is(t, ARRAY) ? [0][CONCAT](t) : n;
  return e && R.is(e, STRING) && a.length - 1 && (e = e.replace(formatrg, function (e, t) {
    return null == a[++t] ? E : a[t];
  })), e || E;
};
var crispFixer = R.vml && .5 || 0;
R.crispBound = cacher(function (e, t, n, a, i) {
  var r,
      o = {};
  return e = e || 0, t = t || 0, n = n || 0, a = a || 0, i = i || 0, r = i % 2 / 2 + crispFixer, o.x = round(e + r) - r, o.y = round(t + r) - r, o.width = round(e + n + r) - r - o.x, o.height = round(t + a + r) - r - o.y, o['stroke-width'] = i, 0 === o.width && 0 !== n && (o.width = 1), 0 === o.height && 0 !== a && (o.height = 1), o;
}, R), elproto.crisp = function () {
  var e,
      t = this,
      n = t.attrs,
      a = t.attr();

  for (e in a = R.crispBound(a.x, a.y, a.width, a.height, a['stroke-width']), a) {
    n[e] === a[e] && delete a[e];
  }

  return t.attr(a);
}, R.define = function (t, n, a, r, o, e) {
  var s, l;

  if (R.is(t, ARRAY)) {
    for (s = 0, l = t.length; s < l; s++) {
      R.define(t[s]);
    }

    return;
  }

  return R.is(t, OBJECT) ? void R.define(t.name, t[t.name], t.ca, t.fn, t.e, t.data) : !t || R.fn[t] ? void 0 : (R.fn[t] = function () {
    var e,
        i = getArrayCopy(arguments),
        s = n.apply(this, i);
    if (r && R.is(r, OBJECT)) for (e in r) {
      s[e] = r[e];
    }
    if (o && R.is(o, OBJECT)) for (e in o) {
      s[e] && s[e](o[e]);
    }

    if (a) {
      if (R.is(a, FUNCTION)) s.ca[t] = a;else for (e in a) {
        s.ca[e] = a[e];
      }
      s.ca[t] && (R._lastArgIfGroup(i, !0), i.length && (i[0][t] ? s.attr.apply(s, i) : s.attr(t, i[0])));
    }

    return s;
  }, a && (R.fn[t].ca = a), r && (R.fn[t].fn = r), o && (R.fn[t].e = o), e && (R.fn[t].data = e), R.fn[t]);
}, function (e, t, _n) {
  function a() {
    /in/.test(e.readyState) ? setTimeout(a, 9) : R.eve('raphael.DOMload');
  }

  null == e.readyState && e.addEventListener && (e.addEventListener(t, _n = function n() {
    e.removeEventListener(t, _n, !1), e.readyState = 'complete';
  }, !1), e.readyState = 'loading'), a();
}(doc, 'DOMContentLoaded'), eve.on('raphael.DOMload', function () {
  loaded = !0;
}), R._preload = function (e, t) {
  var n = g.doc,
      a = n.createElement('img');
  a.style.cssText = 'position:absolute;left:-9999em;top:-9999em', a.onload = function () {
    t.call(this), this.onload = null, n.body.removeChild(this);
  }, a.onerror = function () {
    n.body.removeChild(this);
  }, n.body.appendChild(a), a.src = e;
};
export default R;